<template>
  <div
    class="accountSell"
    v-loading.fullscreen.lock="uploadLoading"
    element-loading-text="文件上传中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="header" v-if="step != 3">
      <div class="headTitle">
        <img
          class="headIcon"
          src="@/assets/image/AccountDeal/gameSelectHead/sellIcon.png"
        />
        <div class="headText">官网寄售</div>
        <div class="headTip">选择您要出售的游戏</div>
      </div>
      <div
        class="headBack"
        v-if="step !== 0 && step !== 3"
        @click="
          Vtype == 'valuation' ? goValuation(selectGame.game_id) : backBtn()
        "
      >
        返回
      </div>
      <!-- <router-link :to="{name:'Home'}" class="headBack" v-else>返回首页</router-link> -->
    </div>
    <div class="step0" v-if="step === 0">
      <gameList
        :gameClick="gameClick"
        :product_id="product_id"
        :gameId="gameId"
        :couponId="couponId"
      ></gameList>
    </div>
    <!-- 选择游戏 -->
    <div class="step1" v-if="step === 1">
      <div class="head">
        <div class="title"><span></span>当前选择游戏为</div>
        <img class="gameImg" :src="selectGame.game_image" />
        <div class="gameName">{{ selectGame.game_name }}</div>
        <div
          class="btn"
          @click="
            Vtype == 'valuation' ? goValuation(selectGame.game_id) : backBtn()
          "
        >
          重选
        </div>
      </div>
      <div class="content1_content">
        <div class="C1C_cardListBtn leftBtn" @click="roll(2)">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="C1C_cardList" ref="nav">
          <!-- 选中游戏名称后显示商品类型 -->
          <div
            ref="C1C_card"
            class="C1C_card"
            v-if="selectGame.game_service.length > 1"
          >
            <div class="C1C_card_title">商品类型</div>
            <el-input
              class="C1C_card_search"
              v-model="search1"
              placeholder="输入关键字"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <div class="C1C_card_list">
              <div
                v-for="(item, index) in searchList(
                  search1,
                  selectGame.game_service
                )"
                :key="index"
                class="C1C_card_item"
                :class="productType === item.name ? 'C1C_card_itemSelect' : ''"
                @click="ProductTypeClick(item)"
              >
                {{ item.name }}
                <span>
                  <img
                    v-show="productType === item.name"
                    src="@/assets/image/AccountDeal/pointerArrow.png"
                    alt=""
                  />
                </span>
              </div>
            </div>
          </div>
          <div
            ref="C1C_card"
            class="C1C_card"
            v-for="(item, index) in c1Item"
            :key="index"
            v-show="item.show && item.entries.length > 0"
          >
            <div v-if="item.entries.length > 0">
              <div class="C1C_card_title">{{ item.cat_name }}</div>
              <el-input
                class="C1C_card_search"
                v-model="item.search"
                @input="
                  val => {
                    cardSearchInput(val, item);
                  }
                "
                placeholder="输入关键字"
              >
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <div class="C1C_card_list">
                <div
                  class="C1C_card_item"
                  :class="
                    c1Form[item.cat_id] === items.id
                      ? 'C1C_card_itemSelect'
                      : ''
                  "
                  @click="c1EntriesClick(item, items, index)"
                  v-for="(items, indexs) in searchList(
                    item.search,
                    item.entries
                  )"
                  :key="indexs"
                >
                  <span>
                    {{ items.name }}
                    <el-popover
                      placement="right"
                      width="150"
                      trigger="hover"
                      content="如何查询是否可二次实名"
                      style="margin: 0 0 0 10px"
                    >
                      <a
                        slot="reference"
                        class="smqk"
                        v-if="
                          (isWzry ||
                            selectGame.game_alias === 'yxlm' ||
                            selectGame.game_alias === 'cyhx' ||
                            selectGame.game_alias === 'hyrz' ||
                            selectGame.game_alias === 'hpjy') &&
                            items.name == '支持人脸包赔'
                        "
                        @click="faceIndeClick"
                      >
                        <img
                          src="@/assets/image/AccountDeal/question.png"
                          alt=""
                        />
                      </a>
                      <a
                        slot="reference"
                        class="smqk"
                        v-else-if="item.cat_name == '实名情况'"
                        target="https://images.pxb7.com/images/upload/image/20211214/1639469291703390.png"
                        @click.stop
                        href="https://images.pxb7.com/images/upload/image/20211214/1639469291703390.png"
                      >
                        <img
                          src="@/assets/image/AccountDeal/question.png"
                          alt=""
                        />
                      </a>
                    </el-popover>
                  </span>
                  <span>
                    <img
                      v-show="c1Form[item.cat_id] === items.id"
                      src="@/assets/image/AccountDeal/pointerArrow.png"
                      alt=""
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            ref="C1C_card"
            class="C1C_card"
            v-for="(item, index) in c1AttrItem"
            :key="'attrItem' + index"
            v-show="item.show"
          >
            <div class="C1C_card_title">{{ item.cat_name }}</div>
            <el-input
              class="C1C_card_search"
              v-model="item.search"
              @input="
                val => {
                  cardSearchInput(val, item);
                }
              "
              placeholder="输入关键字"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <div class="C1C_card_list">
              <div
                class="C1C_card_item"
                :class="
                  c1Form[item.cat_id] === items.id ? 'C1C_card_itemSelect' : ''
                "
                @click="c1EntriesClick(item, items, index)"
                v-for="(items, indexs) in searchList(item.search, item.entries)"
                :key="indexs"
              >
                {{ items.name }}
                <span>
                  <img
                    v-show="c1Form[item.cat_id] === items.id"
                    src="@/assets/image/AccountDeal/pointerArrow.png"
                    alt=""
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="C1C_cardListBtn rightBtn" @click="roll(1)">
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="C1C_selected">
          <div class="C1C_selectedTip">您的选择：</div>
          <div class="C1C_selectedOption">
            <span v-if="selectGame.gameName"
              >{{ selectGame.gameName }}&ensp;<i class="el-icon-arrow-right"></i
              >&ensp;</span
            >
            <span v-if="productType"
              >{{ productType }}&ensp;<i class="el-icon-arrow-right"></i
              >&ensp;</span
            >
            <span v-for="(item, index) in c1FormText" :key="index"
              >{{ item }}&ensp;<i
                class="el-icon-arrow-right"
                v-if="item != ''"
              ></i
              >&ensp;</span
            >
          </div>
          <div class="C1C_selectedBtn">
            <div class="resBtn" @click="c1ResBtn('resetForm')">重选</div>
          </div>
        </div>
      </div>
      <div class="nextBtn" @click="informationSellersOpen" v-if="c1NextBtn">
        下一步 填写信息
      </div>
    </div>
    <!-- 填写信息 -->
    <div class="step2" v-if="step === 2">
      <formTitle
        name="当前选择游戏为"
        :game-image="selectGame.game_image"
        :form-text="c1FormText"
        :game-name="selectGame.game_name"
        :game-id="selectGame.game_id"
        :type-name="productType"
        selected
        :btn-click="backBtn"
      />
      <div class="account" v-if="productType == '游戏帐号'">
        <el-form
          :model="infoForm"
          :rules="rules"
          ref="infoForm"
          label-width="40px"
          class="form"
          :disabled="isEdit"
        >
          <div class="sellLayout">
          <div class="sellLayout__main">
          <!-- 商品基本信息 -->
          <formTitle name="商品基本信息" required></formTitle>
          <div class="card">
            <form-item
              ref="screenshot_method"
              prop="screenshot_method"
              label="截图方式"
              borderBottom
            >
              <div class="question" slot="question" @click="ssmQuestion = true">
                <img src="@/assets/image/AccountDeal/tipQuestion.png" alt="" />
                截图方式区别
              </div>
                <div v-if="isEdit" class="radio" slot="content">
                  <div
                    class="option"
                    :class="{
                      optionSelect: '0' == item.value
                    }"
                    v-for="(item, index) in isEditScreenshotList"
                    :key="index"
                  >
                    {{ item.label }}
                  </div>
                  <div class="screenshot-tips_isedit">
                    （内容修改后默认为“自主截图”）
                  </div>
                </div>
                <div v-else class="radio" slot="content">
                  <div
                    class="option"
                    :class="{
                      optionSelect: infoForm.screenshot_method == item.value
                    }"
                    v-for="(item, index) in screenshotList"
                    :key="index"
                    @click="radioClick(item, infoForm, 'screenshot_method')"
                  >
                    {{ item.label }}
                  </div>
                </div>
              <div
                class="tip"
                slot="tip"
                v-if="selectGame.screenshot_way === 0"
              >
                官方截图：优势：截图描述全面，有助于提高出号效率，缺点：人多审核时间长。<br /><br />
                自主截图：优势：上架展示较快，缺点：描述不足，建议您提供全面的描述与截图，有助于提高出号效率。
              </div>

            </form-item>
            <form-item
              ref="screenshot_method"
              prop="is_exposure"
              label="是否支持一键曝光"
              borderBottom
              v-if="selectGame.game_alias === 'apex' && infoForm.screenshot_method == '1'"
            >
              <div
                class="question"
                slot="question"
                @click="exposureDialog = true"
              >
                <img src="@/assets/image/AccountDeal/tipQuestion.png" alt="" />
                一键曝光说明
              </div>
              <div class="radio" slot="content">
                <div
                  class="option"
                  :class="{ optionSelect: infoForm.is_exposure == item.value }"
                  v-for="(item, index) in is_exposureList"
                  :key="index"
                  @click="radioClick(item, infoForm, 'is_exposure')"
                >
                  {{ item.label }}
                </div>
              </div>
            </form-item>
            <form-item
              ref="accept_bargain"
              prop="accept_bargain"
              label="是否接受议价"
              borderBottom
              v-if="selectGame.can_bargain == 1"
            >
              <div class="radio" slot="content">
                <div
                  class="option"
                  :class="{ optionSelect: infoForm.accept_bargain == item.value }"
                  v-for="(item, index) in acceptBargainData"
                  :key="index"
                  @click="radioClick(item, infoForm, 'accept_bargain')"
                >
                  {{ item.label }}
                </div>
              </div>
            </form-item>
            <form-item
              ref="accept_floor_price"
              prop="accept_floor_price"
              label="是否接受买家底价购买"
              borderBottom
              v-if="selectGame.can_bargain == 1"
              v-show="infoForm.accept_bargain == 1"
            >
              <div
                class="question"
                slot="question"
                @click="acceptFloorPriceShow = true"
              >
                <img src="@/assets/image/AccountDeal/tipQuestion.png" alt="" />
                底价说明
              </div>
              <div class="radio" slot="content">
                <div
                  class="option"
                  :class="{ optionSelect: infoForm.accept_floor_price == item.value }"
                  v-for="(item, index) in acceptFloorPriceData"
                  :key="index"
                  @click="radioClick(item, infoForm, 'accept_floor_price')"
                >
                  {{ item.label }}
                </div>
              </div>
            </form-item>
            <form-item :disabled="false" ref="price" prop="price" label="售价" borderBottom>
              <div class="content" slot="content">
                <el-input
                  v-model="infoForm.price"
                  placeholder="输入商品价格"
                  class="input"
                  autocomplete="new-password"
                ></el-input>
                <div class="tip">元</div>
              </div>
              <div class="tip" slot="tip">
                官网寄售交易
                <span class="priceTip">{{ agentMoney }}元</span>，担保中介交易
                <span class="priceTip">{{ zhongjieMoney }}元</span
                >，按交易类型只收取其一费用。
              </div>
            </form-item>
            <!-- <form-item
              ref="name"
              prop="name"
              label="商品标题"
              borderBottom
              v-if="selectGame.screenshot_way === 2"
            >
              <div class="content" slot="content">
                <el-input
                  v-model="infoForm.name"
                  placeholder="请输入商品标题"
                  class="input nameInput"
                  autocomplete="new-password"
                ></el-input>
              </div>
            </form-item> -->
            <form-item
              ref="image"
              prop="image"
              :label="selectGame.game_alias === 'wmyzf' ? '领主资料封面图' : '商品封面图'"
              borderBottom
              v-if="selectGame.screenshot_way === 2 && selectGame.game_alias === 'wmyzf'"
            >
              <div class="content" slot="content">
                <ossUploadFile
                  class="upload"
                  ref="upload38"
                  fileDir="images/product"
                  accept="image/jpeg, image/png"
                  list-type="picture-card"
                  :show-file-list="false"
                  :limits="1"
                  @upload="addChange38"
                >
                  <template slot="default">
                    <img
                      v-if="infoForm.image"
                      :src="infoForm.image"
                      class="upload_image"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </template>
                </ossUploadFile>
              </div>
            </form-item>
            <el-form
              :model="infoForm"
              :rules="rules"
              ref="infoForm"
              label-width="40px"
              class="form"
            >
              <form-item
                ref="cdata"
                prop="cdata"
                :label="selectGame.game_alias === 'wmyzf' ? '账号详情' : '自主截图'"
                borderBottom
                v-if="isEdit || infoForm.screenshot_method == '0'"
              >
              <div class="question" slot="question" v-if="isEdit">
                可编辑
              </div>
                <div class="content" slot="content">
                  <ul class="el-upload-list el-upload-list--picture-card">
                    <draggable
                      v-model="fileList"
                      style="display: flex; flex-direction: row; flex-wrap: wrap"
                    >
                      <div
                        v-for="(item, index) in fileList"
                        :key="index"
                        class="el-upload-list__item is-success animated"
                      >
                        <img
                          :src="item.file_path"
                          alt=""
                          class="el-upload-list__item-thumbnail"
                        />
                        <i class="el-icon-close"></i>
                        <span class="el-upload-list__item-actions">
                          <span
                            class="el-upload-list__item-preview"
                            @click="handlePictureCardPreview(item)"
                          >
                            <i class="el-icon-zoom-in"></i>
                          </span>
                          <span
                            v-if="!disabled"
                            class="el-upload-list__item-delete"
                            @click="handleRemove(item)"
                          >
                            <i class="el-icon-delete"></i>
                          </span>
                        </span>
                      </div>
                      <ossUploadFile
                        class="upload"
                        :class="{ picUploader: fileList.length >= 1 }"
                        fileDir="images/upload/image"
                        accept="image/jpeg, image/png"
                        list-type="picture-card"
                        ref="upload"
                        multiple
                        :limits="100"
                        :file-list="fileList"
                        :show-file-list="false"
                        @upload="addChange"
                      >
                        <i slot="default" class="el-icon-plus"></i>
                      </ossUploadFile>
                    </draggable>
                    <el-dialog :visible.sync="dialogVisible" top="10vh">
                      <img width="100%" :src="dialogImageUrl" alt="" />
                    </el-dialog>
                  </ul>
                </div>
                <!-- 文明与政府 -->
                <div class="tip" slot="tip" v-if="selectGame.game_alias === 'wmyzf'">
                  领主资料，成就，英雄，技能收藏，文明传承，兵装，列王古卷，背包截图越详细越能吸引买家哦
                  (图片过少将会导致审核失败)
                </div>
                <!-- 原神 || 崩坏星穹铁道 -->
                <div class="tip" slot="tip" v-if="selectGame.game_alias === 'yuanshen' || selectGame.game_alias === 'bhxqtd'">
                  请优先按顺序上传角色图鉴截图与武器截图，再附加其他截图，缺失将影响账号审核，请务必上传。
                </div>
                <div class="tip" slot="tip" v-else>
                  <!-- QQ三国 -->
                  <span v-if="selectGame.game_alias === 'qqsg'"
                    >自主截图内容举例：装备、属性、道具、技能、经络、VIP ，</span
                  >
                  <!-- 三国杀 -->
                  <span v-else-if="selectGame.game_alias === 'sgs'"
                    >游戏个人信息截图，武将截图，动态皮肤截图，背包道具和材料
                    ，</span
                  >
                  <!-- 地下城手游 -->
                  <span v-else-if="selectGame.game_alias === 'dxcsy'"
                    >角色栏，面板，背包，冒险团，宠物，时装及账号细节等等 ，</span
                  >
                  <br />
                  第一张图片将自动作为封面图，截图越详细越能吸引买家哦（图片过少将会导致审核失败）
                </div>
              </form-item>

              <form-item ref="description" prop="description" label="截图备注">
                <div class="question" slot="question" v-if="isEdit">
                  可编辑
                </div>
                <div class="content" slot="content">
                  <el-input
                    type="textarea"
                    class="textarea"
                    :rows="6"
                    v-model="infoForm.description"
                    maxlength="255"
                    show-word-limit
                    placeholder="备注账号亮点，特色。后台自动添加至标题，更有利于快速售出"
                  ></el-input>
                </div>
                <div
                  class="tip"
                  slot="tip"
                  v-if="isEdit"
                >
                请务必在截图备注中书写您新增的游戏道具内容，缺失将影响商品标题新内容展示哦！
                </div>
              </form-item>
            </el-form>
          </div>
          <!-- 账号信息 -->
          <formTitle name="账号信息" required></formTitle>
          <div class="card">
            <form-item
              ref="server"
              prop="server"
              label="具体区服"
              borderBottom
              v-if="selectGame.game_alias === 'lswz' || selectGame.game_alias === 'wmyzf'"
            >
              <div class="content" slot="content">
                <el-input
                  v-model="infoForm.server"
                  class="input"
                  autocomplete="new-password"
                  placeholder="请输入具体区服"
                ></el-input>
                <div class="tip">(例如s1001)</div>
              </div>
            </form-item>
            <el-form
              :model="infoForm"
              :rules="rules"
              ref="infoForm"
              label-width="40px"
              class="form"
              :disabled="isEdit && editType !== '1'"
            >
              <form-item
                ref="game_account"
                prop="game_account"
                label="游戏账号"
                borderBottom
              >
                <div class="question" slot="question" v-if="isEdit && editType === '1'">
                  可编辑
                </div>
                <div class="content" slot="content">
                  <el-input
                    v-model="infoForm.game_account"
                    class="input"
                    autocomplete="new-password"
                    @blur="getProductTransactions(infoForm.game_account)"
                    :placeholder="selectGame.game_alias === 'yuanshen'?'（手机号/邮箱号）非UID':'请输入游戏账号'"
                  ></el-input>
                  <div class="tip" v-if="selectGame.game_alias === 'wmyzf'">
                    (快速查看账号:头像-设置-切换账号)
                  </div>
                </div>
              </form-item>
              <form-item
                ref="camp_account"
                prop="camp_account"
                label="营地账号"
                borderBottom
                v-if="selectGameId == '13'"
              >
                <div
                  class="question"
                  slot="question"
                  @click="camp_accountTipShow = true"
                >
                  <img
                    src="@/assets/image/AccountDeal/tipQuestion.png"
                    alt=""
                  />如何查询营地账号
                  <div @click.stop style="margin-left: 12px;" v-if="isEdit && editType === '1'">
                    可编辑
                  </div>
                </div>
                <div class="content" slot="content">
                  <el-input
                    v-model="infoForm.camp_account"
                    class="input"
                    autocomplete="new-password"
                    placeholder="请输入营地账号"
                  ></el-input>
                </div>
                <div class="tip" slot="tip">
                  麻烦老板打开营地查看权限<span>【否则将无法上架成功！】</span>
                </div>
              </form-item>
            </el-form>
            <form-item
              ref="nobility_level"
              prop="nobility_level"
              label="贵族等级"
              borderBottom
              v-if="isWzry"
            >
              <div class="content" slot="content">
                <el-input
                  v-model="infoForm.nobility_level"
                  class="input"
                  autocomplete="new-password"
                  placeholder="请输入贵族等级"
                ></el-input>
              </div>
            </form-item>
            <!-- 地下城与勇士端游 || 和平精英 -->
            <form-item
              ref="credit_score"
              prop="credit_score"
              :label="selectGame.game_alias === 'dxcyys1' ? '信用分' : '信誉分'"
              borderBottom
              v-if="selectGame.game_alias === 'dxcyys1' || selectGame.game_alias === 'hpjy'"
            >
              <div class="content" slot="content">
                <el-input
                  v-model.trim="infoForm.credit_score"
                  class="input"
                  autocomplete="new-password"
                  :placeholder="selectGame.game_alias === 'dxcyys1' ? '请输入信用分': '请输入信誉分'"
                ></el-input>
              </div>
            </form-item>
            <form-item
              ref="assistant_id"
              prop="assistant_id"
              label="DNF助手ID"
              borderBottom
              v-if="selectGame.game_alias === 'dxcyys1'"
            >
              <div class="content" slot="content">
                <el-input
                  v-model="infoForm.assistant_id"
                  class="input"
                  autocomplete="new-password"
                  placeholder="请输入DNF助手ID"
                ></el-input>
              </div>
            </form-item>
            <el-form
              :model="infoForm"
              :rules="rules"
              ref="infoForm"
              label-width="40px"
              class="form"
              :disabled="isEdit && editType !== '1'"
            >
            <form-item
              ref="game_pwd"
              prop="game_pwd"
              label="登录密码"
              borderBottom
              v-if="
                infoForm.screenshot_method !== '0' &&
                  selectGame.screenshot_way !== 2 &&
                  !isWzry
              "
            >
              <div class="question" slot="question" v-if="isEdit && editType === '1'">
                可编辑
              </div>
              <a
                class="question"
                slot="question"
                href="https://images.pxb7.com/images/upload/image/20220318/1647614551337265.jpeg"
                target="https://images.pxb7.com/images/upload/image/20220318/1647614551337265.jpeg"
                v-if="selectGame.game_alias === 'yuanshen'"
              >
                <img src="@/assets/image/AccountDeal/tipQuestion.png" alt="" />
                关闭手机验证流程
              </a>
              <div class="content" slot="content">
                <el-input
                  v-model="infoForm.game_pwd"
                  class="input"
                  autocomplete="new-password"
                  placeholder="请输入游戏登录密码"
                ></el-input>
              </div>
              <div class="tip" slot="tip" v-if="selectGame.game_alias === 'yuanshen'">
                关闭手机验证提升上架效率，方便快捷出售!
              </div>
              </form-item>
              <form-item
                ref="game_pwd_confirm"
                prop="game_pwd_confirm"
                label="确认登录密码"
                borderBottom
                v-if="
                  infoForm.screenshot_method !== '0' &&
                    selectGame.screenshot_way !== 2 &&
                    !isWzry
                "
              >
                <div class="question" slot="question" v-if="isEdit && editType === '1'">
                  可编辑
                </div>
                <div class="content" slot="content">
                  <el-input
                    v-model="infoForm.game_pwd_confirm"
                    class="input"
                    autocomplete="new-password"
                    placeholder="请再次输入游戏登录密码"
                  ></el-input>
                </div>
              </form-item>
            </el-form>
            <form-item
              ref="game_second_pwd"
              prop="game_second_pwd"
              label="财产安全锁(二级密码)"
              borderBottom
              v-if="selectGame.game_alias === 'tymyd' && infoForm.screenshot_method !== '0'"
            >
              <div class="content" slot="content">
                <el-input
                  v-model="infoForm.game_second_pwd"
                  class="input"
                  autocomplete="new-password"
                  placeholder="仅供截图客户截仓库图使用"
                ></el-input>
              </div>
            </form-item>
            <form-item
              ref="game_second_pwd"
              prop="game_second_pwd"
              label="角色登录密码"
              borderBottom
              v-if="
                (selectGame.game_alias === 'jianling' || selectGame.game_alias === 'qqsg') &&
                  infoForm.screenshot_method !== '0'
              "
            >
              <div class="content" slot="content">
                <el-input
                  v-model="infoForm.game_second_pwd"
                  class="input"
                  autocomplete="new-password"
                  placeholder="登录角色需要，没有不用填写"
                ></el-input>
              </div>
            </form-item>
            <form-item
              ref="is_sell_all"
              prop="is_sell_all"
              label="是否全出"
              borderBottom
              v-if="selectGame.game_alias === 'tymyd'"
            >
              <div class="radio" slot="content">
                <div
                  class="option"
                  :class="{ optionSelect: infoForm.is_sell_all == item.value }"
                  v-for="(item, index) in is_sell_allList"
                  :key="index"
                  @click="radioClick(item, infoForm, 'is_sell_all')"
                >
                  {{ item.label }}
                </div>
              </div>
            </form-item>
            <!-- 填写区服 -->
            <template
              v-if="
                selectGame.game_alias === 'hyrz' ||
                  (selectGame.game_alias === 'lmjxsj' && infoForm.screenshot_method === '0')
              "
            >
              <form-item
                ref="server"
                prop="server"
                label="区服"
                borderBottom
                :rules="[
                  { required: true, message: '请填写区服', trigger: 'blur' },
                  { validator: validService, trigger: 'blur' }
                ]"
              >
                <div class="content" slot="content">
                  <el-input
                    v-model="infoForm.server"
                    @input="handleFilterNotNumer('server')"
                    @keydown.native="handleNumInput"
                    class="input"
                    placeholder="请输入区服"
                  >
                  </el-input>
                </div>
              </form-item>
            </template>
            <!-- V数量" -->
            <template
              v-if="selectGame.game_alias === 'cyhx' && infoForm.screenshot_method === '0'"
            >
              <form-item
                ref="v_number"
                prop="v_number"
                label="V数量"
                borderBottom
              >
                <div class="content" slot="content">
                  <el-input
                    v-model="infoForm.v_number"
                    class="input"
                    @input="handleFilterNotNumer('v_number')"
                    @keydown.native="handleNumInput"
                    placeholder="请输入V数量"
                  >
                  </el-input>
                </div>
                <div class="tip" slot="tip" style="line-height: 22px">
                  上架需真实填写，如填写数据与真实情况不符，买家有权取消交易。如填写数量与真实情况差异过大，游严选有权下架您的商品并封禁您的游严选账号
                </div>
              </form-item>
            </template>
            <!-- 星元皮肤 -->
            <template
              v-if="isWzry && infoForm.screenshot_method === '1'"
            >
              <form-item ref="skins" prop="skins" label="星元皮肤" borderBottom>
                <div class="content" slot="content">
                  <el-select
                    v-model="infoForm.skins"
                    class="select"
                    multiple
                    collapse-tags
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in skinList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </form-item>
            </template>
            <!-- 大国标 -->
            <template
              v-if="isWzry"
            >
              <form-item ref="bigNationalStandard" prop="bigNationalStandard" label="大国标" borderBottom>
                <div class="content" slot="content">
                  <el-select
                    v-model="infoForm.bigNationalStandard"
                    class="select"
                    multiple
                    filterable
                    collapse-tags
                    placeholder="请选择"
                    @change="bigNationalStandardChange"
                  >
                    <el-option
                      v-for="item in bigNationalStandard"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </form-item>
            </template>
            <!-- 小国标 -->
            <template
              v-if="isWzry"
            >
              <form-item ref="smallNationalStandard" prop="smallNationalStandard" label="小国标" borderBottom>
                <div class="content" slot="content">
                  <el-select
                    v-model="infoForm.smallNationalStandard"
                    class="select"
                    multiple
                    filterable
                    collapse-tags
                    placeholder="请选择"
                    @change="smallNationalStandardChange"
                  >
                    <el-option
                      v-for="item in smallNationalStandard"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </form-item>
            </template>
            <!--            穿越火线 音效卡-->
            <template
              v-if="selectGame.game_alias === 'cyhx' && infoForm.screenshot_method === '1'"
            >
              <form-item ref="smallNationalStandard" prop="smallNationalStandard" label="音效卡" borderBottom>
                <div class="content" slot="content">
                  <el-select
                    v-model="infoForm.soundCards"
                    class="select"
                    multiple
                    filterable
                    collapse-tags
                    placeholder="请选择"
                    @change="soundCardsChange"
                  >
                    <el-option
                      v-for="item in soundCards"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      :disabled="item.disabled"

                    >
                    </el-option>
                  </el-select>
                </div>
              </form-item>
            </template>
            <form-item
              ref="acc_source"
              prop="acc_source"
              label="账号来源"
              borderBottom
            >
              <div class="radio" slot="content">
                <div
                  class="option"
                  :class="{ optionSelect: infoForm.acc_source == item.value }"
                  v-for="(item, index) in acc_sourceList"
                  :key="index"
                  @click="radioClick(item, infoForm, 'acc_source')"
                >
                  {{ item.label }}
                </div>
              </div>
              <div class="tip" slot="tip" style="line-height: 22px">
                请老板根据真实信息准确勾选，如交易前客服核对账号来源有误或提供虚假信息，将存在被拉入黑名单并取消交易的风险哦~<br />
                账号来源将直接决定您所签署的合同类型
              </div>
            </form-item>
            <form-item
              ref="cars_num"
              prop="cars_num"
              label="车数"
              borderBottom
              v-if="selectGame.game_alias === 'hpjy'"
            >
              <div class="content" slot="content">
                <el-input
                  v-model="infoForm.cars_num"
                  class="input"
                  autocomplete="new-password"
                  placeholder="请输入车数"
                ></el-input>
              </div>
            </form-item>
            <form-item
              ref="steam_id"
              prop="steam_id"
              label="steamID"
              v-if="selectGame.game_alias === 'jdqs'"
            >
              <div class="content" slot="content">
                <el-input
                  v-model="infoForm.steam_id"
                  class="input"
                  autocomplete="new-password"
                  placeholder="请输入您的steamID"
                ></el-input>
              </div>
              <div class="tip" slot="tip">
                需要Steam的17位ID来查询仓库拥有的装备道具
                <a
                  class="check_steamID"
                  href="https://images.pxb7.com/images/upload/image/20211202/1638436019435456.png"
                  target="https://images.pxb7.com/images/upload/image/20211202/1638436019435456.png"
                >
                  <i class="el-icon-view"></i>
                </a>
              </div>
            </form-item>
          </div>
          <!-- 完善交易选项 -->
          <formTitle name="完善交易选项" required></formTitle>
          <div class="card">
            <form-item
              ref="phone"
              prop="phone"
              label="联系电话"
              borderBottom
              :rules="
                this.$store.state.userData.country_code == '86'
                  ? [
                      {
                        required: true,
                        message: '请输入联系电话',
                        trigger: 'blur'
                      },
                      {
                        pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
                        message: '请输入正确的手机号码',
                        trigger: 'blur'
                      }
                    ]
                  : [
                      {
                        required: true,
                        message: '请输入联系电话',
                        trigger: 'blur'
                      },
                      {
                        pattern: /^\d{4,15}$/,
                        message: '请输入正确的手机号码',
                        trigger: 'change'
                      }
                    ]
              "
            >
              <div class="content" slot="content">
                <el-input
                  v-model="infoForm.phone"
                  class="input"
                  autocomplete="new-password"
                  :maxlength="15"
                  :minlength="4"
                  type="number"
                  placeholder="请输入联系电话"
                ></el-input>
              </div>
            </form-item>
            <form-item ref="qq" prop="qq" label="联系QQ" borderBottom>
              <div class="content" slot="content">
                <el-input
                  v-model="infoForm.qq"
                  class="input"
                  autocomplete="new-password"
                  placeholder="请输入联系QQ"
                ></el-input>
              </div>
            </form-item>
            <form-item ref="wx" prop="wx" label="联系微信" borderBottom>
              <div class="content" slot="content">
                <el-input
                  v-model="infoForm.wx"
                  class="input"
                  autocomplete="new-password"
                  placeholder="请输入联系微信"
                ></el-input>
              </div>
              <div class="tip" slot="tip">请填写微信所绑定的手机号码</div>
            </form-item>
            <form-item
              ref="real_name"
              prop="real_name"
              label="实名情况"
              borderBottom
              v-if="selectGame.game_alias === 'dxcyys1'"
            >
              <a
                class="question"
                slot="question"
                href="https://images.pxb7.com/images/upload/image/20211214/1639469291703390.png"
                target="https://images.pxb7.com/images/upload/image/20211214/1639469291703390.png"
              >
                <img src="@/assets/image/AccountDeal/tipQuestion.png" alt="" />
                如何查询二次实名
              </a>
              <div class="radio" slot="content">
                <div
                  class="option"
                  :class="{ optionSelect: infoForm.real_name == item.value }"
                  v-for="(item, index) in real_nameList"
                  :key="index"
                  @click="radioClick(item, infoForm, 'real_name')"
                >
                  {{ item.label }}
                </div>
              </div>
            </form-item>
            <form-item
              ref="is_premium"
              prop="is_premium"
              label="是否接受议价"
              borderBottom
              v-if="selectGame.can_bargain == 0"
            >
              <div class="radio" slot="content">
                <div
                  class="option"
                  :class="{ optionSelect: infoForm.is_premium == item.value }"
                  v-for="(item, index) in is_premiumList"
                  :key="index"
                  @click="radioClick(item, infoForm, 'is_premium')"
                >
                  {{ item.label }}
                </div>
              </div>
            </form-item>
            <form-item
              ref="is_sign"
              prop="is_sign"
              label="交易保障合同"
              borderBottom
            >
              <div class="radio" slot="content">
                <div
                  class="option"
                  :class="{ optionSelect: infoForm.is_sign == item.value }"
                  v-for="(item, index) in is_signList"
                  :key="index"
                  @click="radioClick(item, infoForm, 'is_sign')"
                >
                  {{ item.label }}
                </div>
              </div>
              <div class="tip" slot="tip">
                <div v-if="infoForm.is_sign == '1'">
                  签署专业法律合同，
                  保障自身与买家权益，账号也可以获得“<span>支持包赔</span>”标签，提供商品关注度和曝光量
                </div>
                <div v-else>
                  商品官网权重降低，影响商品关注度和曝光量，不支持全网全渠道推广宣传
                </div>
              </div>
            </form-item>
            <form-item
              ref="serve"
              prop="serve"
              label="诚心卖服务"
              borderBottom
              v-if="willing_sell.id > 0"
            >
              <div class="radio" slot="content">
                <div
                  class="option"
                  :class="{ optionSelect: infoForm.serve == item.value }"
                  v-for="(item, index) in is_sincerityList"
                  :key="index"
                  @click="radioClick(item, infoForm, 'serve')"
                >
                  {{ item.label }}
                </div>
              </div>
              <div class="tip" slot="tip">
                <div>
                  注：诚心卖商品需支付{{
                    willing_sell.price
                  }}元的诚心卖服务费，诚心卖商品将获得诚心卖标签，且优先给买家展示，详见<span
                    @click="sellSincerityTipShow"
                    style="cursor: pointer"
                    >《诚心卖服务说明及活动说明》</span
                  >
                </div>
              </div>
              <div class="coupon" slot="coupon" v-if="infoForm.serve == 1">
                <div class="line1">
                  <span>支付金额</span
                  ><span class="price">¥{{ willing_sell.price }}</span>
                </div>
                <div class="line2">
                  <span
                    >优惠券
                    <span class="choose" @click="chooseCoupon"
                      >选择其他 <img
                    src="@/assets/image/Coupon/yellowArrow.png"
                    alt=""
                  /></span
                    > </span
                  ><span
                    :class="[
                      coupon_info && coupon_info.list.length == 0
                        ? 'empty'
                        : 'price'
                    ]"
                    >{{
                      coupon_info && coupon_info.list.length == 0
                        ? "暂无可用优惠券"
                        : `¥${(currentCoupon && currentCoupon.amount) || 0}`
                    }}</span
                  >
                </div>
                <div class="line3">
                  <span>应付金额</span
                  ><span class="price">{{ couponTotal }}</span>
                </div>
                <div class="line4" v-if="couponTotal == 0.01">
                  <span class="tips"></span
                  ><span> 诚心卖订单优惠券抵扣后最低需支付0.01元</span>
                </div>
              </div>
            </form-item>
            <form-item
              ref="bind_psn"
              prop="bind_psn"
              label="是否绑定psn"
              borderBottom
              v-if="selectGame.game_alias === 'yuanshen'"
            >
              <div class="radio" slot="content">
                <div
                  class="option"
                  :class="{ optionSelect: infoForm.bind_psn == item.value }"
                  v-for="(item, index) in bind_psnList"
                  :key="index"
                  @click="radioClick(item, infoForm, 'bind_psn')"
                >
                  {{ item.label }}
                </div>
              </div>
            </form-item>
            <form-item
              ref="bind_tap"
              prop="bind_tap"
              label="是否绑定tap"
              borderBottom
              v-if="selectGame.game_alias === 'yuanshen'"
            >
              <div class="radio" slot="content">
                <div
                  class="option"
                  :class="{ optionSelect: infoForm.bind_tap == item.value }"
                  v-for="(item, index) in bind_psnList"
                  :key="index"
                  @click="radioClick(item, infoForm, 'bind_tap')"
                >
                  {{ item.label }}
                </div>
              </div>
            </form-item>
            <!--            <form-item ref="money_income" prop="money_income" label="资金默认转入">
              <div class="radio" slot="content">
                <div class="option optionSelect">
                  我的游严选账户
                </div>
              </div>
              <div class="tip" slot="tip">
                <div>
                  平台账号充值提现开发中，<span>目前支持至银行、支付宝、微信放款</span>，财务将会在交易完成后放款到您指定的账户～
                </div>
              </div>
            </form-item>-->
          </div>
          </div>
          <aside class="sellNotice">
            <div class="sellNotice__card">
              <div class="sellNotice__head">
                <span class="sellNotice__shield">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z"/><path d="M9 12l2 2 4-4"/></svg>
                </span>
                <b>发布须知</b>
                <em>NOTICE</em>
              </div>
              <div class="sellNotice__list">
                <div class="sellNotice__row">
                  <span class="sellNotice__ic">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M14 9V5a3 3 0 0 0-6 0v4M5 9h14l1 11H4z"/></svg>
                  </span>
                  <span class="sellNotice__tx">如实填写账号信息，承诺<b>非黑非租</b>，配合客服核验</span>
                </div>
                <div class="sellNotice__row">
                  <span class="sellNotice__ic">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
                  </span>
                  <span class="sellNotice__tx">上传<b>真实账号截图</b>，资料越全曝光越高</span>
                </div>
                <div class="sellNotice__row">
                  <span class="sellNotice__ic">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                  </span>
                  <span class="sellNotice__tx">合理定价<b>加速成交</b>，平台按成交价收取服务费</span>
                </div>
                <div class="sellNotice__row">
                  <span class="sellNotice__ic">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z"/><path d="M9 12l2 2 4-4"/></svg>
                  </span>
                  <span class="sellNotice__tx">成交即签<b>正规电子合同</b>，全程平台担保留痕</span>
                </div>
              </div>
            </div>
            <div class="sellNotice__trust">
              <div><b>2H</b><span>平均审核</span></div>
              <div><b>担保</b><span>全程托管</span></div>
              <div><b>99.2%</b><span>好评率</span></div>
            </div>
          </aside>
          </div>
          <div class="submit">
            <div
              class="btn"
              :style="{ opacity: submitBtn ? 1 : 0.6, pointerEvents: submitBtn ? 'auto' : 'none' }"
              @click="submit('infoForm')"
            >
              {{ !isEdit && infoForm.serve == 1 ? "支付并发布" : "立即发布" }}
            </div>
            <div class="tip">
              <div class="title">注意:</div>
              <!--              <div>1. 发布后请务必及时联系客服，否则可能无法成功上架！</div>-->
              <div>
                1. 避免违反平台卖号规则,请仔细阅读<span @click="goSellAgreement"
                  >《卖家须知》</span
                >
              </div>
              <div>
                2. 默认卖家手续费，并且确保提交信息正确，否则引起纠纷自己承担
              </div>
              <div
                v-if="selectGameId === 28 && infoForm.screenshot_method == '1'"
              >
                4.
                选择"官方截图"的老板麻烦关闭将军令，以免美工无法登录游戏截图，待收到上架成功的短信提示后在开启将军令！
              </div>
            </div>
            <!-- <div class="tip" v-if="selectGameId===28 && infoForm.screenshot_method == '1'">
              温馨提示：选择"官方截图"的老板麻烦关闭将军令，以免美工无法登录游戏截图，待收到上架成功的短信提示后在开启将军令！
            </div> -->
          </div>
        </el-form>
      </div>
      <div class="equip" v-if="productType == '装备道具'">
        <el-form
          :model="equipmentForm"
          :rules="equipmentRules"
          ref="equipmentForm"
          label-width="40px"
          class="form"
        >
          <div class="sellLayout">
          <div class="sellLayout__main">
          <formTitle name="商品信息" required></formTitle>
          <div class="card">
            <form-item v-if="selectGame.game_alias === 'hpjy'" ref="name" label="商品类目" borderBottom>
              <div class="radio" slot="content">
                <div
                  class="option"
                  :class="{ optionSelect : equipmentForm.volume == item.value }"
                  v-for="(item, index) in hpjysplm"
                  :key="index"
                  @click="radioClick(item, equipmentForm, 'volume')"
                >
                  {{ item.label }}
                </div>
              </div>
            </form-item>
            <form-item
              ref="sell_price"
              prop="sell_price"
              :label="equipmentForm.volume == 0 ? '单件商品价格' : '商品总价格'"
              borderBottom
            >
              <div class="content" slot="content">
                <el-input
                  v-model="equipmentForm.sell_price"
                  :placeholder="equipmentForm.volume == 0 ? '请输入单件价格' : '请输入商品总价格'"
                  class="input"
                  autocomplete="new-password"
                ></el-input>
                <div class="tip">元</div>
              </div>
              <div class="tip" slot="tip">
                代理费：{{ agentMoney }}元，中介费：{{
                  zhongjieMoney
                }}元（收费标准：代理费<span
                  class="priceTip"
                  v-if="gameInfo.equip_agent_fee != 0"
                  >{{ gameInfo.equip_agent_fee }}%</span
                >，最低{{ gameInfo.equip_agent_fee_min }}元，最高{{
                  gameInfo.equip_agent_fee_max
                }}元； 中介费<span
                  v-if="gameInfo.equip_zhongjie_fee != 0"
                  class="priceTip"
                  >{{ gameInfo.equip_zhongjie_fee }}%</span
                >，最低{{ gameInfo.equip_zhongjie_fee_min }}元，最高{{
                  gameInfo.equip_zhongjie_fee_max
                }}元）
              </div>
            </form-item>
            <form-item ref="num" prop="num" label="商品件数" borderBottom>
              <div class="content" slot="content">
                <el-input
                  v-model="equipmentForm.num"
                  placeholder="请输入发布数量"
                  class="input"
                  autocomplete="new-password"
                ></el-input>
                <div class="tip">件</div>
              </div>
            </form-item>
            <form-item v-if="!selectGame || selectGame.game_alias !== 'hpjy'" ref="name" prop="name" label="商品标题" borderBottom>
              <div class="content" slot="content">
                <el-input
                  v-model="equipmentForm.name"
                  placeholder="请输入装备名称"
                  class="input nameInput"
                  autocomplete="new-password"
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </div>
            </form-item>
            <form-item ref="content" prop="content" label="商品描述">
              <div class="content" slot="content">
                <span v-if="selectGame.game_alias === 'hpjy'">{{ hpjyDesc }}</span>
                <el-input
                v-else
                  type="textarea"
                  class="textarea"
                  :rows="9"
                  v-model="equipmentForm.content"
                  maxlength="250"
                  show-word-limit
                  :autosize="{ minRows: 4, maxRows: 6 }"
                  placeholder="请输入商品详细描述，切勿填写与本商品无关的广告信息和联系方式等。"
                ></el-input>
              </div>
            </form-item>
          </div>
          <formTitle name="身份信息" required></formTitle>
          <div class="card">
            <form-item
              ref="game_nickname"
              prop="game_nickname"
              label="游戏角色名称"
              borderBottom
            >
              <div class="content" slot="content">
                <el-input
                  v-model="equipmentForm.game_nickname"
                  placeholder="请输入角色名称"
                  class="input"
                  autocomplete="new-password"
                ></el-input>
              </div>
            </form-item>
            <form-item
              ref="user_phone"
              prop="user_phone"
              label="联系电话"
              borderBottom
              :rules="
                this.$store.state.userData.country_code == '86'
                  ? [
                      {
                        required: true,
                        message: '请输入联系电话',
                        trigger: 'blur'
                      },
                      {
                        pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
                        message: '请输入正确的手机号码',
                        trigger: 'blur'
                      }
                    ]
                  : [
                      {
                        required: true,
                        message: '请输入联系电话',
                        trigger: 'blur'
                      },
                      {
                        pattern: /^\d{4,15}$/,
                        message: '请输入正确的手机号码',
                        trigger: 'change'
                      }
                    ]
              "
            >
              <div class="content" slot="content">
                <el-input
                  v-model="equipmentForm.user_phone"
                  placeholder="请输入联系电话"
                  class="input"
                  type="number"
                  autocomplete="new-password"
                ></el-input>
              </div>
            </form-item>
            <form-item ref="user_qq" prop="user_qq" label="联系QQ">
              <div class="content" slot="content">
                <el-input
                  v-model="equipmentForm.user_qq"
                  placeholder="请输入联系QQ"
                  class="input"
                  autocomplete="new-password"
                ></el-input>
              </div>
            </form-item>
          </div>
          <formTitle name="完善交易选项" required></formTitle>
          <div class="card">
            <form-item
              ref="c_data"
              prop="c_data"
              label="上传详情图片"
              borderBottom
            >
              <div class="content" slot="content">
                <ul class="el-upload-list el-upload-list--picture-card">
                  <draggable
                    v-model="equipfileList"
                    style="display: flex; flex-direction: row; flex-wrap: wrap"
                  >
                    <div
                      v-for="(item, index) in equipfileList"
                      :key="index"
                      class="el-upload-list__item is-success animated"
                    >
                      <img
                        :src="item.file_path"
                        alt=""
                        class="el-upload-list__item-thumbnail"
                      />
                      <i class="el-icon-close"></i>
                      <span class="el-upload-list__item-actions">
                        <span
                          class="el-upload-list__item-preview"
                          @click="equipImageUrlView(item)"
                        >
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span
                          v-if="!equipDisabled"
                          class="el-upload-list__item-delete"
                          @click="equipImgRemove(item)"
                        >
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                    <ossUploadFile
                      class="upload"
                      :class="{ picUploader: equipfileList.length >= 1 }"
                      fileDir="images/equip"
                      accept="image/jpeg, image/png"
                      list-type="picture-card"
                      ref="upload"
                      multiple
                      :limits="100"
                      :file-list="equipfileList"
                      :show-file-list="false"
                      @upload="equipAddChange"
                    >
                      <i slot="default" class="el-icon-plus"></i>
                    </ossUploadFile>
                  </draggable>
                  <el-dialog :visible.sync="equipVisible" top="10vh">
                    <img width="100%" :src="equipImageUrl" alt="" />
                  </el-dialog>
                </ul>
              </div>
              <div class="tip" slot="tip">
                单张图片需小于5M，不能带有角色名、联系方式、广告等违规信息。
              </div>
            </form-item>
            <form-item ref="is_premium" prop="is_premium" label="是否接受议价">
              <div class="radio" slot="content">
                <div
                  class="option"
                  :class="{
                    optionSelect: equipmentForm.is_premium == item.value
                  }"
                  v-for="(item, index) in is_premiumList"
                  :key="index"
                  @click="radioClick(item, equipmentForm, 'is_premium')"
                >
                  {{ item.label }}
                </div>
              </div>
            </form-item>
          </div>
          </div>
          <aside class="sellNotice">
            <div class="sellNotice__card">
              <div class="sellNotice__head">
                <span class="sellNotice__shield">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z"/><path d="M9 12l2 2 4-4"/></svg>
                </span>
                <b>发布须知</b>
                <em>NOTICE</em>
              </div>
              <div class="sellNotice__list">
                <div class="sellNotice__row">
                  <span class="sellNotice__ic">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M14 9V5a3 3 0 0 0-6 0v4M5 9h14l1 11H4z"/></svg>
                  </span>
                  <span class="sellNotice__tx">如实填写商品信息，承诺<b>非黑非租</b>，配合客服核验</span>
                </div>
                <div class="sellNotice__row">
                  <span class="sellNotice__ic">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
                  </span>
                  <span class="sellNotice__tx">上传<b>真实详情图片</b>，资料越全曝光越高</span>
                </div>
                <div class="sellNotice__row">
                  <span class="sellNotice__ic">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                  </span>
                  <span class="sellNotice__tx">合理定价<b>加速成交</b>，平台按成交价收取服务费</span>
                </div>
                <div class="sellNotice__row">
                  <span class="sellNotice__ic">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z"/><path d="M9 12l2 2 4-4"/></svg>
                  </span>
                  <span class="sellNotice__tx">交易<b>全程平台担保</b>，全程留痕可追溯</span>
                </div>
              </div>
            </div>
            <div class="sellNotice__trust">
              <div><b>2H</b><span>平均审核</span></div>
              <div><b>担保</b><span>全程托管</span></div>
              <div><b>99.2%</b><span>好评率</span></div>
            </div>
          </aside>
          </div>
          <div class="submit">
            <div class="btn" @click="c2EquipmentNext('equipmentForm')">
              立即发布
            </div>
            <div class="tip">
              防骗提醒：不要轻易将自己的账号信息泄露给他人，官方客服不会以任何形式向玩家索要您的任何密码、密保等信息，请广大玩家时刻注意保护自己
              的账号信息安全，切勿点击陌生链接！<br />
              <span>【立即联系客服完成上架】</span>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <!--  -->
    <div class="step3" v-if="step === 3">
      <div class="step3_success">
        <div class="success_title">
          <img src="@/assets/image/AccountDeal/sell_success.png" />
          恭喜您商品发布成功！
        </div>
        <div class="success_info">
          <div class="label">商品编号：</div>
          <div class="label_info">{{ unique_no }}</div>
        </div>
        <div class="success_info">
          <div class="label">温馨提示：</div>
          <div class="label_info">
            平台审核并截图上架约30分钟左右,<br />请耐心等待~
          </div>
        </div>
        <div class="success_info" v-if="game_qun.name !== ''">
          <div class="label">交流群：</div>
          <div class="label_info">
            {{ game_qun.name }}<br /><span @click="gotoLink(game_qun.link)"
              ><i class="el-icon-circle-plus-outline"></i>点击加群</span
            >
          </div>
        </div>
        <div class="success_btn" v-if="isEdit">
          <div class="btn cusSerBtn" @click="goProductDetail">查看详情</div>
        </div>
        <div class="success_btn" v-else>
          <div class="btn cusSerBtn" @click="c1ResBtn('reset')">继续发布</div>
          <a
            class="btn"
            v-if="
              selectGame.sys_service_type == 2 ||
                selectGame.sys_service_type == 3
            "
            href="#"
            @click="cusSerBtnClicks"
          >
            联系客服
          </a>
          <a class="btn" v-else :href="link" target="_blank"> 联系客服 </a>
        </div>
        <div class="tip">(上架问题请联系在线客服)</div>
      </div>
      <div class="step3_source" v-if="source_table.length > 0">
        <el-divider content-position="center" class="source_title"
          >您是从哪里知晓的游严选游戏服务网?</el-divider
        >
        <el-radio-group
          class="scource_radio"
          v-model="source"
          size="small"
          @change="handleSource"
        >
          <el-radio
            v-for="item in source_table"
            :key="item.id"
            :label="item.id"
            border
            >{{ item.name }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="downlandAPP">
        <img src="@/assets/image/AccountDeal/downloadApp.gif" alt="" />
      </div>
    </div>
    <!--  截图方式说明  -->
    <el-dialog
      :visible.sync="ssmQuestion"
      custom-class="ssmQuestion"
      :show-close="false"
      width="444px"
      top="35vh"
      center
    >
      <div id="ssmQuestion">
        <div class="answer">
          <div class="title">
            <span></span>
            官方截图：
          </div>
          <div class="text">
            1.由游严选截图美工截取账号详情，编辑标题挂售到官方网站<br />
            2.游严选官方截图完成并上架成功后，建议号主及时修改下密码。
          </div>
        </div>
        <div class="answer">
          <div class="title">
            <span></span>
            自主截图：
          </div>
          <div class="text">
            号主只需提供账号，并进行珍贵道具备注，自主上传游戏截图，编辑标题，越详细越好，有助于提高曝光率及时售出
          </div>
        </div>
        <img
          class="close"
          src="../../../assets/image/AccountDeal/close.png"
          alt=""
          @click="ssmQuestion = false"
        />
      </div>
    </el-dialog>
    <!--  一键曝光说明  -->
    <el-dialog
      :visible.sync="exposureDialog"
      custom-class="ssmQuestion"
      :show-close="false"
      width="386px"
      top="35vh"
      center
    >
      <div id="exposureDialog">
        <div class="exposureDialog_header">一键曝光说明</div>
        <div class="answer">
          <div class="title">
            <span></span>
            如勾选“是”，游严选美工在截图时会为您录制简单的介绍视频，并投放到各大自媒体平台做全方位推广。
          </div>
        </div>
        <div class="answer">
          <div class="title">
            <span></span>
            如勾选“否”，则无此服务。
          </div>
        </div>
        <div class="exposureDialog_tip">
          <img src="@/assets/image/AccountDeal/tipQuestion.png" alt="" />
          一键曝光功能无需加收任何费用
        </div>
        <img
          class="close"
          src="../../../assets/image/AccountDeal/close.png"
          alt=""
          @click="exposureDialog = false"
        />
      </div>
    </el-dialog>
    <!--  王者荣耀 如何查询营地账号  -->
    <el-dialog
      :visible.sync="camp_accountTipShow"
      custom-class="camp_accountDialog"
      top="10vh"
      :show-close="false"
      center
    >
      <div id="camp_accountDialog">
        <img
          class="content"
          src="https://images.pxb7.com/images/upload/image/20220303/1646289484638343.png"
          alt=""
        />
        <img
          class="btn"
          @click="camp_accountTipShow = false"
          src="@/assets/image/AccountDeal/tipClose.png"
          alt=""
        />
      </div>
    </el-dialog>
    <!--  未实名认证弹窗  -->
    <myDialog
      :text="
        '尊敬的游严选VIP您好，根据相关法律法规要求，需先完成实名认证方可挂售。'
      "
      :btn-text="'去实名'"
      btn
      :show="realNameShow"
      :close-fun="mydialogClose"
      :btn-fuc="mydialogBtnClick"
    ></myDialog>
    <!--  人脸包赔弹窗  -->
    <myDialog
      :title="'温馨提示'"
      :text="
        '支持人脸包赔需为本人实名,需在48h解除人脸弹窗,如果未在规定时间内解除,需退还账号全额号款'
      "
      :show="faceIndeShow"
      :close-fun="faceIndeShowClose"
    >
      <div
        slot="btn"
        class="myDialog-btn"
        :class="faceIndeTime > 0 ? 'myDialog-notAllowed' : 'myDialog-Arrow'"
        @click="faceIndeShowClose"
      >
        我知道了 <span v-if="faceIndeTime > 0">({{ faceIndeTime }}S)</span>
      </div>
    </myDialog>

    <sell-sincerity-dia
      :visible.sync="sellSincerityDiaShow"
      :content="willing_sell.agreement_content"
    ></sell-sincerity-dia>
    <!--  卖家须知弹窗  -->
    <informationSellers
      :visible="informationSellersShow"
      @agree="c1Next"
      @close="informationSellersShow = false"
    ></informationSellers>
    <!--  游戏卖号界面提示弹窗  -->
    <myDialog
      :title="'温馨提示'"
      :text="salePopupControllData.context"
      :show="salePopupControllShow"
      :close-fun="salePopupControllShowClose"
    >
      <div
        slot="btn"
        class="myDialog-btn"
        @click="salePopupControllShowClose"
      >
        我知道了
      </div>
    </myDialog>
    <!--  底价购买说明弹窗  -->
    <myDialog
      :title="'底价购买说明'"
      :text="'“底价”为议价进行中卖家同意成交的价格，该价格具有一定的时效性。'"
      :show="acceptFloorPriceShow"
      :close-fun="() => {acceptFloorPriceShow = false}"
    >
      <div
        slot="btn"
        class="myDialog-btn"
        @click="() => {acceptFloorPriceShow = false}"
      >
        我知道了
      </div>
    </myDialog>
    <couponDialog
      ref="couponDialogRef"
      :couponList="coupon_info && coupon_info.list"
      :width="'482'"
      title="选择诚心卖优惠券"
      text="优惠券已放入“个人中心-我的优惠券”"
    >
    </couponDialog>
    <myDialog
      :show="productAddTipShow"
      :title="'温馨提醒'"
      boxPadding="24px 30px"
      :closeFun="() => {productAddTipShow=false}"
      width="358"
      :text="productAddTipText"
    >
      <div
        slot="btn"
        class="myDialog-btn-group"
      >
        <el-button class="btn-default btn-cancel" @click="productAddTipShow=false">取消</el-button>
        <el-button @click="submit('infoForm'),productAddTipShow=false" class="btn-default btn-confirm">确认</el-button>
      </div>
    </myDialog>
  </div>
</template>
<script>
import breadcrumb from "@/components/breadcrumb";
import gameList from "@/components/gameList/index";
import formTitle from "@/views/AccountDeal/AccountSell/formTitle";
import formItem from "@/views/AccountDeal/AccountSell/formItem";
import draggable from "vuedraggable";
import myDialog from "@/components/myDialog";
import informationSellers from "./components/informationSellers";
import { accAdd, accSub } from "@/util/calculate";

import {
  followingEditApi,
  reeditingProductApi,
  getProductInfoApi,
  apiEquipAdd,
  apiEquipAttr,
  apiEquipCategory,
  apiGameInfo,
  apiSalePopupControll,
  apiGoldAttr,
  apiGoldCategory,
  apiProductAdd,
  apiProductCategory,
  apiuserGameSource,
  apiProductPcate,
  apiProductTransactions,
  apiUploadEquip,
  apiUploadPicture,
  apiuserInfo,
  apiGetServicesInfo,
  apiPaypayserve,
  apiServeAdd,
  apiPaySwitch
} from "@/request/API";
import * as imageConversion from "image-conversion";
import OssUploadFile from "@/components/ossUploadFile";
import SellSincerityDia from "./sellSincerityDia.vue";
import couponDialog from "../../AllGame/onlineDeal/couponDialog.vue";

export default {
  name: "accountSell",
  props: {},
  components: {
    OssUploadFile,
    breadcrumb,
    gameList,
    formTitle,
    formItem,
    myDialog,
    draggable,
    SellSincerityDia,
    informationSellers,
    couponDialog
  },
  data() {
    var valiGamePwd = (rule, value, callback) => {
      if (value !== this.infoForm.game_pwd) {
        callback(new Error("两次输入的密码不一致!"));
      } else {
        callback();
      }
    };
    var changeC_Data = (rule, value, callback) => {
      if (this.equipfilePath.length === 0) {
        callback(new Error("请上传详情图片！"));
      } else {
        callback();
      }
    };
    var changeCdata = (rule, value, callback) => {
      if (
        this.filePath.length === 0 &&
        this.infoForm.screenshot_method == "0"
      ) {
        callback(new Error("请上传截图！"));
      } else {
        callback();
      }
    };
    var changeCdata38 = (rule, value, callback) => {
      if (
        this.infoForm.image === "" &&
        this.infoForm.screenshot_method == "0"
      ) {
        callback(new Error("请上传截图！"));
      } else {
        callback();
      }
    };
    var changePrice = (rule, value, callback) => {
      this.agentMoney = (
        (value / 100).toFixed(2) * this.gameInfo.agent_fee
      ).toFixed(2);
      this.zhongjieMoney = (
        (value / 100).toFixed(2) * this.gameInfo.zhongjie_fee
      ).toFixed(2);
      if (this.agentMoney < this.gameInfo.agent_fee_min) {
        this.agentMoney = this.gameInfo.agent_fee_min;
      } else if (this.agentMoney > this.gameInfo.agent_fee_max) {
        this.agentMoney = this.gameInfo.agent_fee_max;
      }
      if (this.zhongjieMoney < this.gameInfo.zhongjie_fee_min) {
        this.zhongjieMoney = this.gameInfo.zhongjie_fee_min;
      } else if (this.zhongjieMoney > this.gameInfo.zhongjie_fee_max) {
        this.zhongjieMoney = this.gameInfo.zhongjie_fee_max;
      }
      if (value > this.gameInfo.price_max || value < this.gameInfo.price_min) {
        callback(
          new Error(
            `售价最低为${this.gameInfo.price_min},最高为${this.gameInfo.price_max}！`
          )
        );
      }
      callback();
    };
    var equipChangePrice = (rule, value, callback) => {
      this.agentMoney = (
        (value / 100).toFixed(2) * this.gameInfo.equip_agent_fee
      ).toFixed(2);
      this.zhongjieMoney = (
        (value / 100).toFixed(2) * this.gameInfo.equip_zhongjie_fee
      ).toFixed(2);
      if (this.agentMoney < this.gameInfo.equip_agent_fee_min) {
        this.agentMoney = this.gameInfo.equip_agent_fee_min;
      } else if (this.agentMoney > this.gameInfo.equip_agent_fee_max) {
        this.agentMoney = this.gameInfo.equip_agent_fee_max;
      }
      if (this.zhongjieMoney < this.gameInfo.equip_zhongjie_fee_min) {
        this.zhongjieMoney = this.gameInfo.equip_zhongjie_fee_min;
      } else if (this.zhongjieMoney > this.gameInfo.equip_zhongjie_fee_max) {
        this.zhongjieMoney = this.gameInfo.equip_zhongjie_fee_max;
      }
      callback();
    };
    var checkData = (rule, value, callback) => {
      if (value) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error("请输入正确的游戏账号!"));
        } else {
          callback();
        }
      }
      callback();
    };
    var validVNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请填写V数量"));
      } else {
        if (!/^[1-9]\d{0,3}$/.test(value)) {
          callback(new Error("最小1,最大9999,只能输入数字"));
        } else {
          callback();
        }
      }
    };
    var validCreditScore = (rule, value, callback) => {
      if(!value){
        if(this.selectGame.game_alias === 'dxcyys1'){
          callback(new Error("请输入信用分"))
        } else {
          callback(new Error("请输入信誉分"))
        }
      } else {
        if(this.selectGame.game_alias === 'dxcyys1'){
          if (isNaN(value)) {
            callback(new Error('请输入正确的信用分'));
          } else {
            if (value > 1200) {
              callback(new Error('请输入正确的信用分'));
            } else {
              callback();
            }
          }
        } else {
          if (!/^(?:[0-9]|[1-9][0-9]|100)$/.test(value)) {
            callback(new Error("请输入正确的信誉分"));
          } else {
            callback();
          }
        }
      }
    }
    return {
      // 底价购买说明弹窗
      acceptFloorPriceShow: false,
      //立即购买 实名弹窗
      realNameShow: false,
      product_id: this.$route.query.product_id || "",
      gameId: this.$route.query.game_id || "",
      // 天涯明月刀估价
      Vtype: "",

      apiUploadPicture: apiUploadPicture,
      // gameList 、 merchantList 、 merchantInfo
      step: 0,
      // 面包屑
      breadcrumbList: [{ name: "我要卖" }, { name: "官网寄售" }],
      // 选择的游戏
      selectGame: "",
      // 商品详情
      productInfo: null,
      //商品类型搜索
      search1: "",
      //选择的商品类型
      productType: "",
      //选中的游戏id
      selectGameId: "",
      c1Item: [],
      c1AttrItem: [],
      c1Form: {},
      c1FormAttr: {},
      c2Item: [],
      c2Form: {},
      c1FormText: {},
      c1FormTextAttr: {},
      c1GameList: [],

      gameInfo: "",

      //手续费
      agentMoney: 0,
      //中介飞
      zhongjieMoney: 0,

      // 站内信选择信息
      stationLetter: {},

      //游戏账号表单
      infoForm: {
        name: "",
        image: "",
        is_sell_all: "",
        acc_source: "",
        server: "",
        game_account: "",
        camp_account: "",
        nobility_level: "",
        credit_score: "",
        assistant_id: "",
        game_pwd: "",
        game_pwd_confirm: "",
        game_second_pwd: "",
        phone: "",
        qq: "",
        wx: "",
        is_premium: "1",
        is_sign: "1",
        bind_psn: "",
        bind_tap: "",
        cdata: "",
        screenshot_method: "1",
        description: "",
        price: "",
        money_income: "1",
        steam_id: "",
        real_name: "",
        is_exposure: "1",
        accept_bargain: "",
        accept_floor_price: "0",
        serve: "",
        v_number: "",
        skins: [],
        bigNationalStandard: [],
        smallNationalStandard: [],
        soundCards:[],
        // 和平精英 车数
        cars_num: '',
      },
      infoForm1: {
        name: "",
        image: "",
        is_sell_all: "",
        acc_source: "",
        server: "",
        game_account: "",
        camp_account: "",
        nobility_level: "",
        credit_score: "",
        assistant_id: "",
        game_pwd: "",
        game_pwd_confirm: "",
        game_second_pwd: "",
        phone: "",
        qq: "",
        wx: "",
        is_premium: "1",
        is_sign: "1",
        bind_psn: "",
        bind_tap: "",
        cdata: "",
        screenshot_method: "1",
        description: "",
        price: "",
        money_income: "1",
        steam_id: "",
        real_name: "",
        is_exposure: "1",
        accept_bargain: "",
        accept_floor_price: "0",
        serve: "",
        v_number: "",
        skins: [],
        bigNationalStandard: [],
        smallNationalStandard: [],
        soundCards:[],
        // 和平精英 车数
        cars_num: '',
      },
      //游戏账号表单校验规则
      rules: {
        name: [{ required: true, message: "请输入商品标题", trigger: "blur" }],
        image: [{ validator: changeCdata38 }],
        is_sell_all: [
          { required: true, message: "请选择是否全出", trigger: "change" }
        ],
        accept_bargain: [
          { required: true, message: "请选择是否接受议价", trigger: "change" }
        ],
        accept_floor_price: [
          { required: true, message: "请选择是否接受买家底价购买", trigger: "change" }
        ],
        acc_source: [
          { required: true, message: "请选择账号来源", trigger: "change" }
        ],
        server: [
          { required: true, message: "请输入具体区服", trigger: "blur" }
        ],
        game_account: [
          { required: true, message: "请输入游戏账号", trigger: "blur" },
          { required: true, validator: checkData, trigger: "blur" }
        ],
        camp_account: [
          { required: true, message: "请输入营地账号", trigger: "blur" },
          { pattern: /^[1-9][0-9]{6,11}$/, message: "营地账号格式错误" }
        ],
        nobility_level: [
          { required: true, message: "请输入贵族等级", trigger: "blur" },
          { pattern: /^([0-9]|10)$/, message: "请输入正确的贵族等级" }
        ],
        credit_score: [
          // { required: true, message: this.selectGame.game_alias === 'dxcyys1' ? "请输入信用分" : "请输入信誉分", trigger: "blur" },
          // { pattern: this.selectGame.game_alias === 'dxcyys1' ? /^[1-9][0-9]{0,4}$/ : /^(?:[0-9]|[1-9][0-9]|100)$/, message: this.selectGame.game_alias === 'dxcyys1' ? "请输入正确的信用分" : "请输入正确的信誉分"}
          { validator: validCreditScore, trigger: "blur" }
        ],
        assistant_id: [
          { required: true, message: "请输入DNF助手ID", trigger: "blur" },
          { pattern: /^[0-9][0-9]{0,11}$/, message: "DNF助手ID格式错误" }
        ],
        game_pwd: [
          { required: true, message: "请输入游戏登录密码", trigger: "blur" }
        ],
        game_pwd_confirm: [
          {
            required: true,
            message: "请再次输入游戏登录密码",
            trigger: "blur"
          },
          { required: true, validator: valiGamePwd, trigger: "blur" }
        ],
        // phone: [
        //   {required: true, message: '请输入联系电话', trigger: 'blur'},
        //   {pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: 'blur'}
        // ],
        qq: [
          { required: true, message: "请输入联系QQ", trigger: "blur" },
          { pattern: /^[1-9][0-9]{4,9}$/, message: "QQ账号格式错误" }
        ],
        wx: [{ required: true, message: "请输入联系微信", trigger: "blur" }],
        real_name: [
          { required: true, message: "请选择实名情况", trigger: "change" }
        ],
        steam_id: [
          { required: true, message: "请输入您的steamID", trigger: "blur" },
          { pattern: /^[1-9][0-9]{16,16}$/, message: "steamID格式错误" }
        ],
        is_premium: [
          { required: true, message: "请选择是否接受议价", trigger: "change" }
        ],
        is_sign: [
          { required: true, message: "请选择交易保障合同", trigger: "change" }
        ],
        bind_psn: [
          { required: true, message: "请选择是否绑定psn", trigger: "change" }
        ],
        bind_tap: [
          { required: true, message: "请选择是否绑定tap", trigger: "change" }
        ],
        screenshot_method: [
          { required: true, message: "请选择截图方式", trigger: "change" }
        ],
        cdata: [{ validator: changeCdata }],
        price: [
          {required: true, message: '请输入商品价格', trigger: 'blur'},
          {pattern: /(^[1-9]\d*$)/, message: '价格仅支持整数'},
          {validator: changePrice, trigger: 'change'}
        ],
        money_income: [
          { required: true, message: "请选择资金转入方式", trigger: "change" }
        ],
        serve: [
          {
            required: true,
            message: "请选择是否购买诚心卖服务",
            trigger: "change"
          }
        ],
        v_number: [
          { required: true, message: "请填写V数量", trigger: "blur" },
          { validator: validVNumber, trigger: "blur" }
        ]
      },
      //游戏装备表单
      equipmentForm: {
        name: "",
        sell_price: "",
        num: "",
        content: "",
        game_nickname: "",
        user_phone: "",
        user_qq: "",
        image: "",
        c_data: "",
        // is_proof: '1', //是否有价值证明  0无  1有
        // proof: '',
        is_premium: "1",
        volume:'0' // 和平精英类目
      },
      equipmentForm1: {
        name: "",
        sell_price: "",
        num: "",
        content: "",
        game_nickname: "",
        user_phone: "",
        user_qq: "",
        image: "",
        c_data: "",
        // is_proof: '1', //是否有价值证明  0无  1有
        // proof: '',
        is_premium: "1",
        volume:'0' // 和平精英类目
      },
      //游戏装备表单校验规则
      equipmentRules: {
        name: [{ required: true, message: "请输入装备名称", trigger: "blur" }],
        sell_price: [
          {required: true, message: '请输入单件价格', trigger: 'blur'},
          {pattern: /(^[1-9]\d*$)/, message: '价格仅支持整数'},
          {validator: equipChangePrice, trigger: 'change'}
        ],
        num: [
          { required: true, message: "请输入发布数量", trigger: "blur" },
          { pattern: /^[1-9]\d*$/, message: "请输入正确的数量" }
        ],
        content: [
          { required: true, message: "请输入商品描述", trigger: "blur" }
        ],
        game_nickname: [
          { required: true, message: "请输入游戏角色名", trigger: "blur" }
        ],
        // user_phone: [
        //   {required: true, message: '请输入联系电话', trigger: 'blur'},
        //   {pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: 'blur'}
        // ],
        user_qq: [
          { required: true, message: "请输入QQ号", trigger: "blur" },
          { pattern: /^[1-9][0-9]{4,9}$/, message: "QQ账号格式错误" }
        ],
        c_data: [
          { validator: changeC_Data }
          // {required: true, message: '请上传详情图片'},
        ],
        // is_proof: [
        //   {required: true, message: '请选择是否有价值证明', trigger: 'change'}
        // ],
        is_premium: [
          { required: true, message: "请选择是否接受议价", trigger: "change" }
        ]
      },

      //截图方式
      screenshotList: [
        { value: "1", label: "游严选官方截图" },
        { value: "0", label: "自主截图" }
      ],
      // 编辑状态截图方式
      isEditScreenshotList: [
        { value: "1", label: "游严选官方截图" },
        { value: "0", label: "自主截图" }
      ],
      //一键曝光
      is_exposureList: [
        { value: "1", label: "是" },
        { value: "0", label: "否" }
      ],
      // 是否接受议价
      acceptBargainData: [
        { value: "1", label: "接受议价" },
        { value: "0", label: "不接受议价" }
      ],
      // 是否接受买家底价购买
      acceptFloorPriceData: [
        { value: "1", label: "同意将求降价最底价亮给买家" },
        { value: "0", label: "不亮出最底价，默认通过议价成交" }
      ],
      //是否全出
      is_sell_allList: [
        { value: "0", label: "全出" },
        { value: "1", label: "只出游戏（给安全中心）" },
        { value: "2", label: "只出游戏（不给安全中心）" }
      ],
      //账号来源
      acc_sourceList: [
        { value: "0", label: "自己注册" },
        { value: "1", label: "游严选平台购买" },
        // {value: '2', label: '其他平台购买（入手已满6个月）'},
        // {value: '3', label: '其他平台购买（入手未满6个月）'},
        { value: "4", label: "其它渠道购买" }
      ],
      //实名情况
      real_nameList: [
        { value: "1", label: "可二次实名" },
        { value: "0", label: "不可二次实名" }
      ],
      //是否接受议价
      is_premiumList: [
        { value: "1", label: "接受" },
        { value: "0", label: "不接受" }
      ],
      //和平精英商品类目
      hpjysplm: [
        { value: "0", label: "和平精英车币" },
        { value: "1", label: "和平精英碎片" }
      ],
      //交易保障合同
      is_signList: [
        { value: "1", label: "签署" }
        // {value: '0', label: '不签署'},
      ],
      //是否签署诚心卖
      is_sincerityList: [
        { value: "1", label: "购买服务" },
        { value: "0", label: "不购买服务" }
      ],
      //是否绑定psn
      bind_psnList: [
        { value: "1", label: "是" },
        { value: "0", label: "否" }
      ],
      //是否绑定tap
      bind_tapList: [
        { value: "1", label: "是" },
        { value: "0", label: "否" }
      ],
      //截图方式提示弹窗
      ssmQuestion: false,
      //一键曝光说明弹窗
      exposureDialog: false,
      //游戏账号 自主截图
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      //游戏账号 自主截图文件列表
      fileList: [],
      //游戏账号 自主截图文件path列表
      filePath: [],
      //王者荣耀 如何查询营地账号
      camp_accountTipShow: false,
      //提交按钮
      submitBtn: true,
      //发布成功之后返回的编号
      unique_no: "",
      //游戏装备详情 图片上传
      equipImageUrl: "",
      equipVisible: false,
      equipDisabled: false,
      //游戏装备详情 图片上传文件列表
      equipfileList: [],
      //游戏装备详情 图片上传文件path列表
      equipfilePath: [],
      //下一步 填写信息按钮显示
      c1NextBtn: false,
      uploadLoading: false,
      // 提交账号来源
      source: "",
      // 交流群
      game_qun: {},
      // 发布提交用户来源
      source_table: [],
      link: "",
      //支持人脸包赔弹窗
      faceIndeShow: false,
      faceIndeTime: 3,
      // 诚心卖服务tip弹窗
      sellSincerityDiaShow: false,
      // 诚心卖服务配置
      willing_sell: {},
      //卖家须知弹窗
      informationSellersShow: false,
      skinList: [], //星元皮肤
      bigNationalStandard: [], //大国标
      smallNationalStandard: [], //小国标
      soundCards:[],// 音效卡
      coupon_info: {},
      currentCoupon: {},
      couponId: "",
      //游戏卖号界面提示
      salePopupControllData:{},
      salePopupControllShow:false,
      bigNationalStandardId: '',
      smallNationalStandardId: '',
      soundCardsId:'',
      isEdit: false,
      statusType: '',
      // 商品关闭求降价-提交二次确认弹窗
      productAddTipShow: false,
      // 当前商品已关闭求降价，请确认是否继续发布文案
      productAddTipText: '',
      // 当前商品已关闭求降价继续发布
      canNotBargain: true,
      // 求降价是否再次提交
      againSubmit: false,
    };
  },
  async created() {
    this.Vtype = this.$route.query.type;
    if (this.$route.query?.sincerity) {
      this.sinceritySucc();
    }
    // 二次编辑新增逻辑
    const { pageType, product_id, game_id, statusType } = this.$route.query
    this.isEdit = pageType === 'edit'
    // 待跟进 1 二次审核失败 2 在售为 3
    this.statusType = statusType
    if(this.isEdit) {
      this.productInfo = await getProductInfoApi({
        product_id,
        game_id,
       }).then(({code, data}) => code === 200 ? data : {})
       const { category, game_pwd, services, screenshot_method } = this.productInfo
       const skins = category.find(item => item.cat_name === '星元皮肤')?.attr.map(item => item.id)
       const bigNationalStandard = category.find(item => item.cat_name === '大国标')?.attr.map(item => item.id)
       const smallNationalStandard = category.find(item => item.cat_name === '小国标')?.attr.map(item => item.id)
      const soundCards = category.find(item => item.cat_name === '音效卡')?.attr.map(item => item.id)

       this.infoForm = {
        ...this.productInfo,
        game_pwd_confirm: game_pwd,
        serve: services,
        screenshot_method: screenshot_method + '',
        // 星元 大国表 小国标
        skins,
        bigNationalStandard,
        smallNationalStandard,
         soundCards
       }
    }
  },
  methods: {
    // 二次编辑成功查看详情
    goProductDetail() {
      const { product_id, game_id } = this.$route.query
      this.$router.push({
        path: '/personalCenter/seller/sellInfo',
        query: {
          game_id,
          id: product_id,
        }
      })
    },
    // 音效卡选择
    soundCardsChange(data){
      const selectSound = this.soundCards.find(item=>item.name=='未拥有')
      this.soundCards.forEach(v=>{
        if(data.includes(selectSound.id)){
          v.disabled= v.name!='未拥有'
        }else{
          v.disabled=v.name=='未拥有'
        }
      })
      if(!data.length){
        this.soundCards.forEach(v=>{
          v.disabled=false
        })
      }
    },
    /**
     * @description: 小国标change
     * @return {*}
     */
    smallNationalStandardChange() {
      let {name, nameArr} = this.NationalStandard('smallNationalStandard')
      if(nameArr){
        nameArr.forEach(item => {
          if(name.indexOf(item.name) >=0){
            this.infoForm.bigNationalStandard.splice(this.infoForm.bigNationalStandard.findIndex(v => v == item.id),1)
          }
        })
      }
    },
    /**
     * @description: 大国标change
     * @return {*}
     */
    bigNationalStandardChange() {
      let {name, nameArr} = this.NationalStandard('bigNationalStandard')
      if(nameArr){
        nameArr.forEach(item => {
          if(name.indexOf(item.name) >=0){
            this.infoForm.smallNationalStandard.splice(this.infoForm.smallNationalStandard.findIndex(v => v == item.id),1)
          }
        })
      }
    },
    /**
     * @description: 获取当前选中id的name，兄弟的数据对象
     * @param {*} key1
     * @return {*}
     */
    NationalStandard(key1) {
      if(key1 == 'bigNationalStandard'){
        let name = []
        this.bigNationalStandard.forEach(item => {
          this.infoForm.bigNationalStandard.forEach(v => {
            if(item.id == v){
              name.push(item.name)
            }
          })
        });
        let nameArr = []
        this.smallNationalStandard.forEach(item => {
          this.infoForm.smallNationalStandard.forEach(v => {
            if(item.id == v){
              nameArr.push(item)
            }
          })
        });
        return {name, nameArr}
      } else {
        let name = []
        let nameArr = []
        this.bigNationalStandard.forEach(item => {
          this.infoForm.bigNationalStandard.forEach(v => {
            if(item.id == v){
              nameArr.push(item)
            }
          })
        });

        this.smallNationalStandard.forEach(item => {
          this.infoForm.smallNationalStandard.forEach(v => {
            if(item.id == v){
              name.push(item.name)
            }
          })
        });
        return {name, nameArr}
      }
    },
    chooseCoupon() {
      if (this.isEdit) {
        return
      }
      if (this.coupon_info && this.coupon_info.list.length != 0) {
        if (!this.currentCoupon.id) {
          this.$refs.couponDialogRef.showDialog({});
        } else {
          this.$refs.couponDialogRef.showDialog(this.currentCoupon);
        }
      }
    },
    ChooseCouponNow(item) {
      this.currentCoupon = item;
    },
    handleNumInput(e) {
      // 处理禁用键盘e键
      const key = e.key;
      if (
        [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "Backspace",
          ".",
          "ArrowLeft",
          "ArrowRight"
        ].includes(key)
      ) {
        e.returnValue = true;
        return;
      } else {
        e.returnValue = false;
        return;
      }
    },
    handleFilterNotNumer(key) {
      this.infoForm[key] = this.infoForm[key]?.replace(/[^\d.]/g, "");
    },
    validService(rule, value, callback) {
      if (!value) {
        callback(new Error("请填写区服"));
      } else {
        if (!/^[1-9]\d{0,3}$/.test(value)) {
          callback(new Error("区服最小1,最大9999,只能输入数字"));
        } else {
          callback();
        }
      }
    },
    /**
     * @description: 卖家须知
     * @return {*}
     */
    goSellAgreement() {
      let routeData = this.$router.resolve({
        name: "SellAgreement"
      });
      window.open(routeData.href, "_blank");
    },
    async sinceritySucc() {
      this.step = 3;
      this.active = 0;
      let gameinfo = await apiGameInfo({ id: this.$route.query.gameid });
      this.selectGame = gameinfo.data;
      this.submitBtn = true;
      let game_qun = gameinfo.data.game_qun.split(",");

      this.unique_no = this.$route.query.uniqueno;
      this.game_qun.name = game_qun[0];
      this.game_qun.link = game_qun[1];
      this.link = gameinfo.data.game_customer;
    },
    /**
     * @description: 诚心卖
     * @return {*}
     */
    sellSincerityTipShow() {
      this.sellSincerityDiaShow = true;
    },
    /**
     * 关闭实名认证提示框
     */
    mydialogClose() {
      this.realNameShow = false;
    },
    mydialogBtnClick() {
      this.$router.push({
        path: "/personalCenter/personalInfo/rNameAuthentication",
        query: {
          Rurl: this.$route.fullPath
        }
      });
    },
    cusSerBtnClicks() {
      this.$openIM({
        ysdgcode: "htmg",
        gameAlias: "htmg"
      });
    },
    /**
     * 跳转链接
     * @param link 链接
     */
    gotoLink(link) {
      window.open(link);
    },
    /**
     * @description: 提交来源
     * @return {*}
     */
    handleSource() {
      apiuserGameSource({
        game_id: this.selectGameId,
        source: this.source
      }).then(res => {
        this.$message.success("提交成功！");
        this.source_table = [];
      });
    },
    /**
     * 点击游戏事件
     * @param game
     * @param next:true,false 判断是否站内信
     * @param sLetter 接收组件传送的站内信数据
     */
    async gameClick(game, next, sLetter,is_search_click,original_key_word) {
      if (!this.isEdit) {
        this.$sensorsTrack.SellGameSelect(game.game_id,game.game_name,is_search_click,original_key_word)
      }
      this.productType = ''
      this.c1Item = ''
      this.salePopupControllData = {}
      if (this.$store.state.loginStatus) {
        let userInfo = await apiuserInfo({ action: "verified" });
        let gameInfo = await apiGameInfo({ id: game.game_id });
        let salePopupControllData = await apiSalePopupControll({ game_id: game.game_id });
        this.salePopupControllData = salePopupControllData.data
        // 卖家实名预校验（缺陷#10）：未完成实名(auth_state != 1)禁止挂售，
        // 在选择游戏时即提前引导去实名，避免填完整张表单才在提交时被后端拦截。
        if (
          userInfo.data.auth_state != 1 &&
          this.$store.state.userData.country_code == "86"
        ) {
          this.realNameShow = true;
          return;
        }
        this.selectGame = gameInfo.data;
        this.selectGameId = game.game_id;
        this.stationLetter = { ...sLetter };
        if(this.isEdit) {
          this.stationLetter = {...this.productInfo}
          this.step = 2;
        } else {
          this.step = 1;
        }

        //如果选择的游戏 商品类型只有一个 默认选上
        if (game.game_service.length === 1 || next) {
          this.ProductTypeClick(game.game_service[0]);
        }
      } else {
        this.$message({
          type: "error",
          message: "尚未登录，请先登录。",
          center: true
        });
        this.$router.push({
          path: "/login",
          query: {
            Rurl: this.$route.fullPath,
            game_name: this.game_name,
            game_id: this.game_id,
            id: this.id
      }
        });
      }
    },
    /**
     * 返回按钮
     */
    backBtn() {
      if(this.isEdit) {
        window.history.go(-1)
        return
      }
      this.c1ResBtn("back");
    },
    /**
     * @description: 返回估价
     * @return {*}
     */
    goValuation(game_id) {
      this.$router.push({
        name: "AccountValuation"
      });
    },
    /**
     * 步骤一 scoll滚动
     */
    roll(index) {
      let maxScrollLeft =
        this.$refs.nav.scrollWidth - this.$refs.nav.clientWidth;
      if (index == 1) {
        let $this = this.$refs.nav;
        setTimeout(function animation() {
          if ($this.scrollLeft < maxScrollLeft) {
            setTimeout(() => {
              //步进速度
              $this.scrollLeft = $this.scrollLeft + 5;
              //返回顶部
              if ($this.scrollLeft < maxScrollLeft) {
                $this.scrollLeft = $this.scrollLeft + 5;
              }
              animation();
            }, 5);
          }
        }, 10);
      } else {
        let $this = this.$refs.nav;
        //返回顶部动画特效
        setTimeout(function animation() {
          if ($this.scrollLeft > 0) {
            setTimeout(() => {
              //步进速度
              $this.scrollLeft = $this.scrollLeft - 5;
              //返回顶部
              if ($this.scrollLeft > 0) {
                $this.scrollLeft = $this.scrollLeft - 5;
              }
              animation();
            }, 5);
          }
        }, 10);
      }
    },

    /**
     * 步骤一 选择商品类型
     */
    ProductTypeClick(item) {
      this.productType = item.name;
      this.c1Item = [];
      this.c1AttrItem = [];
      this.c1Form = {};
      this.c1FormAttr = {};
      this.c2Item = [];
      this.c2Form = {};
      this.c1FormText = {};
      this.c1FormTextAttr = {};
      this.c1GameList = [];
      this.getZoneList(this.selectGameId);

      // this.getGameList(item.type)
    },

    /**
     * 步骤一 搜索游戏名称
     * @param indexKey 关键词
     * @param list 数组
     */
    searchList(indexKey, list) {
      if (indexKey) {
        var reg = new RegExp(indexKey, "ig");
        return list.filter(function(e) {
          //匹配所有字段
          return Object.keys(e).some(function(key) {
            if (typeof e[key] == "string") {
              return e[key].match(reg);
            }
          });
          this.$forceUpdate();
        });
      }
      return list;
    },

    /**
     * 获取游戏大区列表
     */
    getZoneList(game_id, next) {
      apiGameInfo({
        id: this.selectGameId
      }).then(res => {
        this.gameInfo = res.data;
        // console.log(this.gameInfo);
        this.agentMoney = this.gameInfo.agent_fee_min;
        this.zhongjieMoney = this.gameInfo.zhongjie_fee_min;
        // if(next){
        //   let item = this.gameInfo.game_service.find(child=>child.name=='游戏帐号')
        //   this.ProductTypeClick(item)
        // }
      });
      switch (this.productType) {
        case "游戏帐号":
          apiProductCategory({
            game_id: game_id,
            type: "sale"
          }).then(res => {
            res.data.forEach((item, index) => {
              if (
                item.unique_id != "rzhs" &&
                item.unique_id != "ajg" &&
                item.is_gaoji !== 1 &&
                item.unique_id != "ahy"
              ) {
                this.c1Item.push(item);
                this.$set(this.c1Form, item.cat_id, "");
                this.$set(this.c1FormText, item.cat_id, "");
              }

              if (item.is_gaoji === 1) {
                if (item.haveAttr) {
                  this.c2Item.push(item);
                  this.$set(this.c2Form, item.cat_id, "");
                }
              }

              if (item.cat_id === 33 && this.isWzry) {
                this.skinList = item.entries;
              }
              if (item.unique_id == 'dgb' && this.isWzry) {
                this.bigNationalStandard = item.entries;
                this.bigNationalStandardId = item.cat_id
              }
              if (item.unique_id == 'xgb' && this.isWzry) {
                this.smallNationalStandard = item.entries;
                this.smallNationalStandardId = item.cat_id;
              }
              if (item.unique_id == 'YXK' && this.selectGame.game_alias === 'cyhx') {
                this.soundCards = item.entries;
                this.soundCards.forEach(v=>{
                  this.$set(v,'disabled',false)
                })
                this.soundCardsId = item.cat_id;
              }
            });

            this.c1Item.forEach((item, index) => {
              item.search = "";
              if (index === 0) {
                item.show = true;
                if (this.stationLetter.game_id) {
                  this.getC1ItemFrist(item, index);
                }
              } else {
                item.show = this.stationLetter.game_id ? true : false;
              }
              if (item.parent_id == 0) {
                this.getC1ItemFrist(item, index);
              }
            });
          });
          break;
        case 2:
          apiGoldCategory({
            game_id: game_id,
            type: "sale"
          }).then(res => {
            res.data.forEach((item, index) => {
              if (
                item.unique_id != "rzhs" &&
                item.unique_id != "ajg" &&
                item.is_gaoji !== 1
              ) {
                this.c1Item.push(item);
                this.$set(this.c1Form, item.cat_id, "");
                this.$set(this.c1FormText, item.cat_id, "");
              }
              if (item.is_gaoji === 1) {
                if (item.haveAttr) {
                  this.c2Item.push(item);
                  this.$set(this.c2Form, item.cat_id, "");
                }
              }
            });
            this.c1Item.forEach((item, index) => {
              if (index === 0) {
                item.show = true;
              } else {
                item.show = false;
              }
            });
          });
          break;
        case "装备道具":
          apiEquipCategory({
            game_id: game_id,
            type: "sale"
          }).then(res => {
            res.data.forEach((item, index) => {
              if (item.unique_id != "rzhs" && item.cat_name != "按价格") {
                // if (item.entries.length > 0) {
                this.c1Item.push(item);
                this.$set(this.c1Form, item.cat_id, "");
                this.$set(this.c1FormText, item.cat_id, "");
                // } else {
                //   item.search = ''
                //   this.c1AttrItem.push(item)
                //   this.$set(this.c1Form, item.cat_id, '')
                //   this.$set(this.c1FormText, item.cat_id, '')
                // }
              }
              if (item.is_gaoji === 1) {
                if (item.haveAttr) {
                  this.c2Item.push(item);
                  this.$set(this.c2Form, item.cat_id, "");
                }
              }
            });
            this.c1Item.forEach((item, index) => {
              if (index === 0) {
                item.show = true;
              } else {
                item.show = false;
              }
            });
          });
          break;
      }
    },
    /**
     * 属性选择搜索值变化
     * @param item card item
     * @param val 变化后的值
     */
    cardSearchInput(val, item) {
      this.$set(item, item.search, val);
      this.$forceUpdate();
    },
    /**
     * 步骤一 选项点击监听
     */
    async c1EntriesClick(item, items, index) {
      let storage;
      if (index < this.c1Item.length - 1) {
        storage = this.c1Form[this.c1Item[index + 1].cat_id];
      }
      if (item.haveChild) {
        if (items.haveChild) {
          switch (this.productType) {
            case "游戏帐号":
              await apiProductPcate({
                game_id: this.selectGameId,
                pid: items.id
              }).then(res => {
                //下一步按钮隐藏
                this.c1NextBtn = false;
                for (let resKey in res.data.list) {
                  this.c1Item.forEach((c1items, c1indexs) => {
                    if (c1items.cat_id === parseInt(resKey)) {
                      c1items.canShow = true;
                      c1items.entries.splice(0, c1items.entries.length);
                      res.data.list[resKey].forEach((keyItem, keyIndex) => {
                        c1items.entries.push(keyItem);
                      });
                      if (this.stationLetter.category) {
                        this.$nextTick(() => {
                          this.getC1ItemFrist(c1items, c1indexs);
                        });
                      }
                    }
                  });
                }
                for (let key in this.c1Form) {
                  for (const keyKey in res.data.list) {
                    if (key == keyKey) {
                      if (storage == "") {
                        this.c1Form[key] = "";
                      } else {
                        this.c1Form[key] = "-1";
                      }
                      this.c1FormText[key] = "";
                    }
                  }
                }
              });
              break;
            case 2:
              await apiGoldAttr({
                game_id: this.selectGameId,
                pid: items.id
              }).then(res => {
                for (let resKey in res.data.list) {
                  this.c1Item.forEach((c1items, c1indexs) => {
                    if (c1items.cat_id === parseInt(resKey)) {
                      c1items.entries.splice(0, c1items.entries.length);
                      res.data.list[resKey].forEach((keyItem, keyIndex) => {
                        c1items.entries.push(keyItem);
                      });
                    }
                  });
                }
                for (let key in this.c1Form) {
                  for (const keyKey in res.data.list) {
                    if (key == keyKey) {
                      if (storage == "") {
                        this.c1Form[key] = "";
                      } else {
                        this.c1Form[key] = "-1";
                      }
                      this.c1FormText[key] = "";
                    }
                  }
                }
              });
              break;
            case "装备道具":
              await apiEquipAttr({
                game_id: this.selectGameId,
                pid: items.id
              }).then(res => {
                //下一步按钮隐藏
                this.c1NextBtn = false;
                this.c1AttrItem.forEach((c1items, c1indexs) => {
                  if (c1items.entries.length > 0) {
                    c1items.entries = [];
                  }
                });
                let c1form = Object.keys(this.c1Form);
                let c1formvalue = Object.values(this.c1Form);
                let c1formText = Object.keys(this.c1FormText);
                let c1formTextvalue = Object.values(this.c1FormText);
                this.c1Form = {};
                this.c1FormAttr = {};
                this.c1FormText = {};
                this.c1FormTextAttr = {};
                c1form.forEach((item, index) => {
                  this.c1Item.forEach((c1item, c1index) => {
                    if (c1item.cat_id == item) {
                      this.$set(this.c1Form, item, c1formvalue[index]);
                    }
                  });
                });
                c1formText.forEach((item, index) => {
                  this.c1Item.forEach((c1item, c1index) => {
                    if (c1item.cat_id == item) {
                      this.$set(this.c1FormText, item, c1formTextvalue[index]);
                    }
                  });
                });

                for (let resKey in res.data.list) {
                  this.c1Item.forEach((c1items, c1indexs) => {
                    if (c1items.cat_id === parseInt(resKey)) {
                      c1items.canShow = true;
                      c1items.entries.splice(0, c1items.entries.length);
                      res.data.list[resKey].forEach((keyItem, keyIndex) => {
                        c1items.entries.push(keyItem);
                      });
                    }
                  });
                }
                for (let key in this.c1Form) {
                  for (const keyKey in res.data.list) {
                    if (key == keyKey) {
                      if (storage == "") {
                        this.c1Form[key] = "";
                      } else {
                        this.c1Form[key] = "-1";
                      }
                      this.c1FormText[key] = "";
                    }
                  }
                }
                this.c1Form = Object.assign(this.c1Form, this.c1FormAttr);
                this.c1FormText = Object.assign(
                  this.c1FormText,
                  this.c1FormTextAttr
                );
              });
              break;
          }
        } else {
          this.c1AttrItem.forEach((c1items, c1indexs) => {
            c1items.entries = [];
          });
          let c1form = Object.keys(this.c1Form);
          let c1formvalue = Object.values(this.c1Form);
          let c1formText = Object.keys(this.c1FormText);
          let c1formTextvalue = Object.values(this.c1FormText);
          this.c1Form = {};
          this.c1FormAttr = {};
          this.c1FormText = {};
          this.c1FormTextAttr = {};
          c1form.forEach((item, index) => {
            this.c1Item.forEach((c1item, c1index) => {
              if (c1item.cat_id == item) {
                this.$set(this.c1Form, item, c1formvalue[index]);
              }
            });
          });
          c1formText.forEach((item, index) => {
            this.c1Item.forEach((c1item, c1index) => {
              if (c1item.cat_id == item) {
                this.$set(this.c1FormText, item, c1formTextvalue[index]);
              }
            });
          });
          this.c1Item.forEach((c1items, c1indexs) => {
            if (c1items.parent_id === item.cat_id) {
              this.c1Item[c1indexs].canShow = false;
              this.c1Item[c1indexs].entries.splice(
                0,
                this.c1Item[c1indexs].entries.length
              );
              this.$set(this.c1Form, c1items.cat_id, -2);
              this.$set(this.c1FormText, c1items.cat_id, "");
            }
          });
        }
      }

      if (index < this.c1Item.length - 1) {
        if (
          !this.c1Item[index + 1].canShow &&
          this.c1Item[index + 1].entries.length === 0
        ) {
          this.c1Item[index + 2].show = true;
        } else {
          this.c1Item[index + 1].show = true;
        }
        this.$forceUpdate();
      }

      if (this.c1Form[item.cat_id] == "" && this.c1Item.length - 1 !== index) {
        this.watchRef();
      }
      this.c1Form[item.cat_id] = items.id;
      this.c1FormText[item.cat_id] = items.name;
      this.$forceUpdate();
      for (let c1FormKey in this.c1Form) {
        if (
          this.c1Form[c1FormKey] != "" &&
          this.c1Form[c1FormKey] != 0 &&
          this.c1Form[c1FormKey] != -1
        ) {
          this.c1NextBtn = true;
        } else {
          this.c1NextBtn = false;
          return;
        }
      }
    },
    //选中按大区
    getC1ItemFrist(objList, indexNum) {
      let cat_name = objList.cat_name;
      if (!this.stationLetter.category) return;
      let categoryChild = this.stationLetter.category.find(
        item => item.cat_name == cat_name
      );
      if (!categoryChild) {
        this.stationLetter = {};
        return;
      }
      let entries = objList.entries.find(child => {
        return child.name == categoryChild.attr_name[0];
      });
      if (entries) {
        this.c1EntriesClick(objList, entries, indexNum);
      }
    },
    /**
     * 步骤一 ref
     */
    watchRef() {
      if (this.$refs["C1C_card"]) {
        if (this.$refs["C1C_card"].length > 2) {
          let $this = this.$refs.nav;
          let c1cLength = this.$refs["C1C_card"].length;
          let maxScrollLeft =
            this.$refs.nav.scrollWidth - this.$refs.nav.clientWidth;
          if (maxScrollLeft < (c1cLength - 2) * 185) {
            maxScrollLeft = maxScrollLeft + 185;
          }
          let move = setTimeout(function animation() {
            if ($this.scrollLeft < maxScrollLeft) {
              setTimeout(() => {
                //步进速度
                $this.scrollLeft = $this.scrollLeft + 5;
                //返回顶部
                if ($this.scrollLeft < maxScrollLeft) {
                  $this.scrollLeft = $this.scrollLeft + 5;
                }
                animation();
              }, 5);
            }
          }, 10);
        }
      }
    },
    /**
     * 步骤一 重选
     */
    c1ResBtn(param) {
      this.source = "";
      this.equipfileList = [];
      this.equipfilePath = [];
      this.fileList = [];
      this.filePath = [];
      switch (this.step) {
        case 1:
        case 3:
          this.c1Item = [];
          this.c1AttrItem = [];
          this.c1Form = {};
          this.c1FormAttr = {};
          this.c2Item = [];
          this.c2Form = {};
          this.c1FormText = {};
          this.c1FormTextAttr = {};
          switch (param) {
            case "back":
              this.step--;
              this.selectGameId = "";
              this.c1GameListLabel = "";
              this.productType = "";
              this.c1NextBtn = false;
              break;
            case "reset":
              if (this.$route.query?.sincerity) {
                this.$router.push({
                  path: "/accountSell"
                });
              }
              //如果选择的游戏 商品类型只有一个 默认选上
              if (this.selectGame.game_service.length === 1) {
                this.ProductTypeClick(this.selectGame.game_service[0]);
              } else {
                this.productType = "";
              }
              for (let infoFormKey in this.infoForm) {
                this.infoForm[infoFormKey] = this.infoForm1[infoFormKey];
              }
              if (this.step === 3) {
                this.step = 0;
              } else {
                this.step--;
              }
              for (let equipFormKey in this.equipmentForm) {//重置装备表单数据
                this.equipmentForm[equipFormKey] = this.equipmentForm1[equipFormKey];
              }
              break;
            case "resetForm":
              //如果选择的游戏 商品类型只有一个 默认选上
              if (this.selectGame.game_service.length === 1) {
                this.ProductTypeClick(this.selectGame.game_service[0]);
              } else {
                this.productType = "";
              }
              this.c1NextBtn = false;
              break;
          }
          break;
        case 2:
          this.step--;
          for (let infoFormKey in this.infoForm) {
            this.infoForm[infoFormKey] = this.infoForm1[infoFormKey];
          }
          for (let equipFormKey in this.equipmentForm) {//重置装备表单数据
            this.equipmentForm[equipFormKey] = this.equipmentForm1[equipFormKey];
          }
          break;
      }
    },

    /**
     * 下一步按钮 弹出卖家须知
     */
    informationSellersOpen(){
      this.$sensorsTrack.AddProductBasicInformation(
        this.selectGame.game_id,
        this.selectGame.game_name,
        this.selectGame.game_service[this.selectGame.game_service.findIndex(v => v.name == this.productType)].id,
        this.productType
      )
      this.informationSellersShow = true
      if (this.salePopupControllData.flag == 1) {
        this.salePopupControllShow = true;
      }
    },
    /**
     * 下一步 填写信息
     */
    c1Next() {
      this.c1Item.forEach((item, index) => {
        if (item.parent_id !== 0) {
          if (item.entries.length === 0) {
            for (const c1FormKey in this.c1Form) {
              if (c1FormKey == item.cat_id) {
                this.$set(this.c1Form, c1FormKey, -1);
                this.$set(this.c1FormText, c1FormKey, "");
              }
            }
          }
        }
      });

      if (this.$store.state.loginStatus) {
        let flag = true;
        for (let c1FormKey in this.c1Form) {
          if (
            this.c1Form[c1FormKey] === "" ||
            this.c1Form[c1FormKey] === 0 ||
            this.c1Form[c1FormKey] == -1
          ) {
            flag = false;
          }
        }
        this.c1Item.forEach((item, index) => {
          if (!item.canShow) {
            flag = true;
          }
        });
        if (flag) {
          if (
            this.selectGame.game_alias === 'hpjy' ||
            this.selectGame.screenshot_way === 2
          ) {
            this.infoForm.screenshot_method = "0";
          }
          if (this.step++ >= 2) this.step = 0;
          document.body.scrollTop = document.documentElement.scrollTop = 157;
          apiuserInfo({
            action: "base"
          }).then(res => {
            this.infoForm.phone = res.data.used_phone
              ? res.data.used_phone
              : res.data.telphone;
            /**
             * 判断是否是站内信的数据
             */
            if (this.stationLetter.id) {
              this.fileList = [];
              let str = this.stationLetter.cdata || "";
              let strA = this.isWzry ? '[]' : this.stationLetter.arms_data || "";
              let arr = [...JSON.parse(str), ...JSON.parse(strA)];
              for (var i = 0; i < arr.length; i++) {
                this.fileList.push({
                  url: arr[i]
                });
                this.filePath.push({
                  path: arr[i]
                });
              }
              if (this.fileList.length > 0) {
                this.infoForm.screenshot_method = "0";
              }
              this.infoForm.qq = this.stationLetter.qq;
            } else {
              this.infoForm.qq = res.data.used_qq
                ? res.data.used_qq
                : res.data.qq;
            }
            this.infoForm.wx = res.data.used_wx;

            this.equipmentForm.user_phone = res.data.used_phone
              ? res.data.used_phone
              : res.data.telphone;
            this.equipmentForm.user_qq = res.data.used_qq
              ? res.data.used_qq
              : res.data.qq;
            // this.goldForm.user_phone = res.data.telphone

            // this.goldForm.user_qq = res.data.qq
          });
        } else {
          this.$message({
            message: "有未选项",
            center: true,
            type: "error"
          });
        }
      } else {
        this.$message({
          type: "error",
          message: "尚未登录，请先登录。",
          center: true
        });
        this.$router.push({
          path: "/login",
          query: {
            Rurl: this.$route.path,
            game_name: this.game_name,
            game_id: this.game_id,
            id: this.id
          }
        });
      }
    },
    /**
     * 单选 点击事件
     * @param item 选中项
     * @param form 表单
     * @param formkey 表单属性
     */
    radioClick(item, form, formkey) {
      if (this.isEdit) {
        return
      }
      this.$set(form, formkey, item.value);
    },
    /**
     * 游戏账号 乱世王者 商品封面图上传
     * @param file 文件
     */
    async addChange38(file) {
      this.infoForm.image = file;
      /*
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
        this.$refs.upload.uploadFiles = this.$refs.upload.uploadFiles.filter(val => val.uid !== file.uid)
        return
      }
      let newFile = await imageConversion.compressAccurately(file.raw, {
        size: 1024,
        type: 'image/jpeg'
      })
      file.raw = new File([newFile],this.uuid()+".jpeg",{type:file.type,lastModified: Date.now()})
      this.uploadLoading = true
      let data = new FormData()
      data.append('file', file.raw)
      this.apiUploadPicture(data).then(res => {
        this.infoForm.image = res.data.file_path
      }).catch(err => {
        this.$message({
          type: "error",
          center: true,
          message: err.msg + '(5M以内的png或jpg格式的图片)'
        })
      }).finally(()=>{
        this.uploadLoading = false
      })*/
    },
    /**
     * @description: 生成唯一标识
     * @return {*}
     */
    uuid() {
      let s = [];
      let hexDigits = "0123456789abcdef";
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      let uuid = s.join("");
      return uuid;
    },
    /**
     * 游戏账号 自主截图上传
     * @param file 文件
     */
    async addChange(file) {
      file.files.forEach(async (item, index) => {
        let newFile = await imageConversion.compressAccurately(item.raw, {
          size: 1024,
          type: "image/jpeg"
        });
        item.raw = new File([newFile], this.uuid() + ".jpeg", {
          type: item.type,
          lastModified: Date.now()
        });
        let data = new FormData();
        data.append("file", item.raw);
        let datas = new Object();
        datas.path = item.url;
        datas.uid = item.uid;
        item.file_path = item.url;
        this.$set(
          this.fileList,
          file.files.findIndex(items => items === item),
          item
        );
        this.$set(
          this.filePath,
          file.files.findIndex(items => items === item),
          datas
        );
      });
      /*      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
        this.$refs.upload.uploadFiles = this.$refs.upload.uploadFiles.filter(val => val.uid !== file.uid)
        return
      }
      let newFile = await imageConversion.compressAccurately(file.raw, {
        size: 1024,
        type: 'image/jpeg'
      })
      file.raw = new File([newFile],this.uuid()+".jpeg",{type:file.type,lastModified: Date.now()})
      let data = new FormData()
      this.uploadLoading = true
      data.append('file', file.raw)
      this.apiUploadPicture(data).then(res => {
        let data = new Object()
        data.path = res.data.file_path
        data.uid = file.uid
        file.file_path = res.data.file_path
        this.$set(this.fileList,fileList.findIndex(item => item === file),file)
        this.$set(this.filePath,fileList.findIndex(item => item === file),data)
      }).catch(err => {
        this.$refs.upload.uploadFiles = this.$refs.upload.uploadFiles.filter(val => val.uid !== file.uid)
        this.$message({
          type: "error",
          center: true,
          message: err.msg + '(5M以内的png或jpg格式的图片)'
        })
      }).finally(()=>{
        this.uploadLoading = false
      })*/
    },
    /**
     * 步骤二 游戏账号 自主截图删除
     */
    handleRemove(file) {
      this.fileList.splice(
        this.fileList.findIndex(item => item.uid === file.uid),
        1
      );
      this.filePath.splice(
        this.filePath.findIndex(item => item.uid === file.uid),
        1
      );
    },
    /**
     * 步骤二 游戏账号 自主截图查看
     */
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    /**
     * 获取游戏账号在本平台的交易次数
     * @param account
     */
    getProductTransactions(account) {
      if (this.selectGame.game_alias === 'qqsg') {
        apiProductTransactions({
          game_id: this.selectGameId,
          game_acc: account
        }).then(res => {
          if (res.data.transactionsNum === 0) {
            this.accSourceDisable = true;
            if (this.infoForm.acc_source == 1) {
              this.infoForm.acc_source = "";
            }
          } else {
            this.accSourceDisable = false;
          }
        });
      }
    },

    /**
     * 步骤二 游戏账号 发布商品
     * @param formName 表单名称
     */
    submit(formName) {
      if (this.submitBtn) {
        // 防重复提交：同步置为提交中，避免 validate 异步回调期间二次点击造成重复 POST
        this.submitBtn = false
        this.$refs[formName].validate(async (valid, object) => {
          if (valid) {
            if(this.selectGame.game_alias === 'cyhx' && this.infoForm.screenshot_method === '1' && !this.infoForm.soundCards.length){
              this.$message.error('请选择音效卡')
              this.submitBtn = true
              return
            }
            if(this.isWzry && this.infoForm.game_account == this.infoForm.camp_account){
              this.$message.error('请正确输入营地ID')
              this.scrollView({camp_account: []})
              this.submitBtn = true
              return
            }
            let status = '提交成功'
            // category
            let dgb = this.bigNationalStandardId
            let xgb = this.smallNationalStandardId
            let YXK = this.soundCardsId

            let category =
              this.isWzry
                ? { ...this.c1Form, ...this.c2Form, 33: this.infoForm.skins, [dgb]: this.infoForm.bigNationalStandard, [xgb]: this.infoForm.smallNationalStandard }
                : { ...this.c1Form, ...this.c2Form };
            if(this.selectGame.game_alias === 'cyhx' && this.infoForm.screenshot_method === '1'){
              category={
                ...category,
                [YXK]:this.infoForm.soundCards
              }
            }
            for (const categoryKey in category) {
              if (category[categoryKey] < 0) {
                category[categoryKey] = 0
              }
            }
            this.submitBtn = false
            this.infoForm.cdata = ''
            this.infoForm.cdata = this.infoForm.cdata + '<p>'
            if (!this.isEdit && this.infoForm.image != '') {
              this.infoForm.cdata = this.infoForm.cdata + '<img src="' + this.infoForm.image + '">'
            }
            this.filePath.forEach(item => {
              this.infoForm.cdata = this.infoForm.cdata + '<img src="' + item.path + '">'
            })
            this.infoForm.cdata = this.infoForm.cdata + '</p>'
            // 新老求降价议价字段判断传参
            let canBargain
            if(this.selectGame.can_bargain == 1) {
              // 新求降价
              // againSubmit再次提交时不传新求降价字段
              canBargain = !this.againSubmit ? {
                accept_bargain: this.infoForm.accept_bargain === '' ? 0 : this.infoForm.accept_bargain,
                accept_floor_price: this.infoForm.accept_bargain == 0 || this.infoForm.accept_bargain === '' ?  0 : this.infoForm.accept_floor_price,
                is_premium: 0
              } : {is_premium: this.infoForm.accept_bargain === '' ? 0 : this.infoForm.accept_bargain}
            } else {
              // 老求降价
              canBargain = {is_premium: this.infoForm.is_premium,}
            }

            let productAddData = {
              name: this.infoForm.name,
              image: this.infoForm.image,
              game_id: this.selectGameId,
              is_sell_all: this.infoForm.is_sell_all,
              acc_source: this.infoForm.acc_source,
              game_account: this.infoForm.game_account,
              camp_account: this.infoForm.camp_account,
              nobility_level: this.infoForm.nobility_level,
              credit_score: this.infoForm.credit_score,
              assistant_id: this.infoForm.assistant_id,
              game_pwd: this.infoForm.game_pwd,
              game_pwd_confirm: this.infoForm.game_pwd_confirm,
              game_second_pwd: this.infoForm.game_second_pwd,
              phone: this.infoForm.phone,
              qq: this.infoForm.qq,
              wx: this.infoForm.wx,
              is_sign: this.infoForm.is_sign,
              bind_psn: this.infoForm.bind_psn,
              bind_tap: this.infoForm.bind_tap,
              cdata:
                this.infoForm.screenshot_method == "0"
                  ? this.infoForm.cdata
                  : "",
              screenshot_method: this.infoForm.screenshot_method,
              description: this.infoForm.description,
              price: this.infoForm.price,
              steam_id: this.infoForm.steam_id,
              real_name: this.infoForm.real_name,
              is_exposure:
                this.infoForm.screenshot_method == "1"
                  ? this.infoForm.is_exposure
                  : "",
              ...canBargain,
              category: JSON.stringify(category),
              serve: this.infoForm.serve,
              cars_num: this.infoForm.cars_num || '',
            };
            // 游戏为-穿越火线
            if (
              this.selectGame.game_alias === 'cyhx' &&
              this.infoForm.screenshot_method == "0"
            ) {
              productAddData.v_number = this.infoForm.v_number;
            }
            if (
              ['lswz', 'wmyzf', 'hyrz'].includes(this.selectGame.game_alias) ||
              (this.selectGame.game_alias === 'lmjxsj' &&
                this.infoForm.screenshot_method === "0")
            ) {
              productAddData.server = this.infoForm.server;
            }
            if (this.isEdit) {
              const { product_id, game_id } = this.$route.query
              const { cdata, description, game_pwd, game_pwd_confirm, game_account, camp_account} = this.infoForm
              let p = {
                screenshot: cdata,
                description,
                game_id,
                product_id,
              }
              if (this.statusType === '1') {
                p = {
                  ...p,
                  game_pwd,
                  game_pwd_confirm,
                  game_account,
                  camp_account,
                }
              }
              await (this.statusType === '1' ? followingEditApi : reeditingProductApi)(p).then(res => {
                if (this.step++ >= 3) this.active = 0;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                this.$message({
                  message: "发布成功",
                  center: true,
                  type: "success"
                })
                this.submitBtn = true
                const { unique_no, game_qun, table, link } = res.data
                this.unique_no = unique_no
                this.game_qun = game_qun
                this.source_table = table
                this.link = link
              }).catch(err => {
                this.$message({
                  message: err.msg,
                  center: true,
                  type: "error"
                })
                status = '提交失败-' + err.msg
                this.submitBtn = true
              })
            } else {
              await apiProductAdd(productAddData).then(async res => {
                // 兜底：任何非成功业务码都必须回显，杜绝“点了发布、200、却毫无反应”的静默失败
                if (!res || res.code !== 200) {
                  this.$message({
                    message: (res && res.msg) || '发布失败，请稍后重试',
                    center: true,
                    type: "error"
                  })
                  this.submitBtn = true
                  return
                }
                if (this.infoForm.serve==1){
                  await apiServeAdd({
                    game_id: this.selectGameId,
                    product_id: res.data.id,
                      goods_type: 1,
                      user_coupon_id: this.currentCoupon && this.currentCoupon.id
                    })
                      .then(ress => {
                    this.$router.push({
                      name: 'MethodOfPayment',
                      query: {
                        type: 2,
                        orderid: ress.data.id,
                        id: res.data.id,
                        gameid: this.selectGameId,
                        uniqueno: res.data.unique_no,
                            amount:
                              accSub(
                                10,
                                (this.currentCoupon &&
                                  this.currentCoupon.amount * 1) ||
                                  0
                              ) || 0.01
                      }
                        });
  /*                  apiPaySwitch({
                      game_id: this.selectGameId,
                      type: 2
                    }).then(resp => {
                      if(resp.data.is_lianlian_pay == 1){
                        this.$router.push({
                          name: 'MethodOfPayment',
                          query: {
                            type: 2,
                            orderid: ress.data.id,
                            id: res.data.id,
                            gameid: this.selectGameId,
                            uniqueno: res.data.unique_no,
                            amount: 10
                          }
                        })
                      } else {
                        this.$router.push({
                          path: '/payserveBlank',
                          query: {
                            gameid: this.selectGameId,
                            id: res.data.id,
                            orderid: ress.data.id,
                            uniqueno: res.data.unique_no
                          },
                        })
                      }
                    })*/
                  }).catch(() => {
                    if (this.step++ >= 3) this.active = 0;
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    this.$message({
                      message: "发布成功",
                      center: true,
                      type: "success"
                    })
                    this.submitBtn = true
                    this.unique_no = res.data.unique_no
                    this.game_qun = res.data.game_qun
                    this.source_table = res.data.table
                    this.link = res.data.link
                  })
                  // this.$router.push('Sinceritypayment')
                } else {
                  this.againSubmit = false
                  if (this.step++ >= 3) this.active = 0;
                  document.body.scrollTop = document.documentElement.scrollTop = 0;
                  this.$message({
                    message: "发布成功",
                    center: true,
                    type: "success"
                  })
                  this.submitBtn = true
                  this.unique_no = res.data.unique_no
                  this.game_qun = res.data.game_qun
                  this.source_table = res.data.table
                  this.link = res.data.link
                }
              }).catch(err => {
                if(err && err.code == 10005){
                this.productAddTipText = err.data;
                this.productAddTipShow = true
                this.againSubmit = true
                this.canNotBargain = false
              } else {
                // 任何后端业务错误/网络异常都回显，绝不静默
                this.$message({
                  message: (err && err.msg) || '发布失败，请稍后重试',
                  center: true,
                  type: "error"
                })
              }
                status = '提交失败-' + ((err && err.msg) || '未知错误')
                this.submitBtn = true
              })
            }
            // 埋点
            this.$sensorsTrack.AddProductDetailInformation(
              this.source_page,
              this.infoForm.screenshot_method == 1 ? '游严选官网截图':this.infoForm.screenshot_method == 0 ? '自主截图':'',
              this.infoForm.price,
              this.infoForm.acc_source == 0 ? '自己注册':this.infoForm.acc_source == 1 ? '游严选平台购买':this.infoForm.acc_source == 4 ? '其他渠道购买':'',
              this.infoForm.is_premium == 1 ? true : false,
              this.infoForm.serve == 1 ? 1: 0,
              this.productType,
              this.selectGame.game_service[this.selectGame.game_service.findIndex(v => v.name == this.productType)].id,
              this.selectGame.game_id,
              this.selectGame.game_name,
              status
            )
          } else {
            this.submitBtn = true
            this.scrollView(object)
            /*
                        setTimeout(() => {
                          var isError = document.getElementsByClassName("is-error");
                          if (isError[0].querySelector('input')) {
                            isError[0].querySelector('input').focus();
                          } else if (isError[0].querySelector('textarea')) {
                            isError[0].querySelector('textarea').focus();
                          }
                        }, 100);
                        console.log('error submit!!');
                        return false;*/
          }
        });
      }
    },

    /**
     * 表单验证失败时 滚动到第一个error位置
     * @param object 表单验证失败的对象
     */
    scrollView(object) {
      const key = Object.keys(object); // key得到的是表单绑定的值
      let dom = this.$refs[key[0]]; // dom是第一项没有通过的值，需要注意的是vue中获取dom元素用的是ref，所以必须在含有表单校验规则的项上绑定ref，与v-model值相同。
      dom.$el.scrollIntoView({
        // 该scrollIntoView()方法将调用它的元素滚动到浏览器窗口的可见区域。
        block: "center",
        behavior: "smooth"
      });
    },

    /**
     * 步骤二 游戏装备 详情图片删除
     */
    equipImgRemove(file) {
      this.equipfileList.splice(
        this.equipfileList.findIndex(item => item.uid === file.uid),
        1
      );
      this.equipfilePath.splice(
        this.equipfilePath.findIndex(item => item.uid === file.uid),
        1
      );
    },
    /**
     * 步骤二 游戏装备 详情图片查看
     */
    equipImageUrlView(file) {
      this.equipImageUrl = file.url;
      this.equipVisible = true;
    },
    /**
     * 步骤二 游戏装备 装备详情图片上传
     * @param file 文件
     */
    async equipAddChange(file) {
      file.files.forEach(async (item, index) => {
        let newFile = await imageConversion.compressAccurately(item.raw, {
          size: 1024,
          type: "image/jpeg"
        });
        item.raw = new File([newFile], this.uuid() + ".jpeg", {
          type: item.type,
          lastModified: Date.now()
        });
        let data = new FormData();
        data.append("file", item.raw);
        let datas = new Object();
        datas.path = item.url;
        datas.uid = item.uid;
        item.file_path = item.url;
        this.$set(
          this.equipfileList,
          file.files.findIndex(items => items === item),
          item
        );
        this.$set(
          this.equipfilePath,
          file.files.findIndex(items => items === item),
          datas
        );
      });
      /*      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
        this.$refs.upload.uploadFiles = this.$refs.upload.uploadFiles.filter(val => val.uid !== file.uid)
        return
      }
      let newFile = await imageConversion.compressAccurately(file.raw, {
        size: 1024,
        type: 'image/jpeg'
      })
      file.raw = new File([newFile],this.uuid()+".jpeg",{type:file.type,lastModified: Date.now()})
      let data = new FormData()
      data.append('file', file.raw)
      apiUploadEquip(data).then(res => {
        let data = new Object()
        data.path = res.data.file_path
        data.uid = file.uid
        file.file_path = res.data.file_path
        this.$set(this.equipfileList,fileList.findIndex(item => item === file),file)
        this.$set(this.equipfilePath,fileList.findIndex(item => item === file),data)
      }).catch(err => {
        this.$refs.equipUpload.uploadFiles = this.$refs.equipUpload.uploadFiles.filter(val => val.uid !== file.uid)
        this.$message({
          type: "error",
          center: true,
          message: err.msg + '(5M以内的png或jpg格式的图片)'
        })
      })*/
    },
    /**
     * 步骤二 游戏装备 发布商品
     * @param formName 表单名称
     */
    c2EquipmentNext(formName) {
      if(this.selectGame.game_alias === 'hpjy'){
        this.equipmentForm.name = this.equipmentForm.volume == '0' ? '和平精英车币' : '和平精英碎片'
        this.equipmentForm.content = this.hpjyDesc
      }
      if (this.submitBtn) {
        this.submitBtn = false;
        this.$refs[formName].validate((valid, object) => {
          if (valid) {
            // let category = {...this.c1Form, ...this.c2Form}
            this.equipmentForm.c_data = "";
            this.equipmentForm.c_data = this.equipmentForm.c_data + "<p>";
            this.equipfilePath.forEach((item, index) => {
              if (index === 0) {
                this.equipmentForm.image = item.path;
              }
              this.equipmentForm.c_data =
                this.equipmentForm.c_data + '<img src="' + item.path + '">';
            });
            this.equipmentForm.c_data = this.equipmentForm.c_data + "</p>";
            /*        this.equipmentForm.proof = this.equipmentForm.proof + '<p>'
                    this.provefilePath.forEach((item, index) => {
                      this.equipmentForm.proof = this.equipmentForm.proof + '<img src="' + item.path + '">'
                    })*/
            this.equipmentForm.proof = this.equipmentForm.proof + "</p>";
            let category = this.c1Form;
            for (const categoryKey in category) {
              if (category[categoryKey] < 0) {
                category[categoryKey] = 0;
              }
            }
            apiEquipAdd({
              is_premium: this.equipmentForm.is_premium,
              game_id: this.selectGameId,
              name: this.equipmentForm.name,
              content: this.equipmentForm.content,
              sell_price: this.equipmentForm.sell_price,
              num: this.equipmentForm.num,
              image: this.equipmentForm.image,
              c_data: this.equipmentForm.c_data,
              game_nickname: this.equipmentForm.game_nickname,
              // is_proof: this.equipmentForm.is_proof,
              // proof: this.equipmentForm.proof,
              user_phone: this.equipmentForm.user_phone,
              user_qq: this.equipmentForm.user_qq,
              category: JSON.stringify(category)
            })
              .then(res => {
                if (this.step++ >= 3) this.step = 0;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                this.$message({
                  message: "发布成功",
                  center: true,
                  type: "success"
                });
                this.submitBtn = true;
                // this.centerDialogVisible = true
                this.unique_no = res.data.unique_no;
              })
              .catch(err => {
                this.$message({
                  message: err.msg,
                  center: true,
                  type: "error"
                });
                this.submitBtn = true;
              });
          } else {
            this.submitBtn = true;
            this.scrollView(object);
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    /**
     * 人脸包赔 点击按钮
     */
    faceIndeClick() {
      this.faceIndeShow = true;
      this.faceIndeTime = 3;
      let timer = setInterval(() => {
        this.faceIndeTime--;
        if (this.faceIndeTime === 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    faceIndeShowClose() {
      if (this.faceIndeTime === 0) {
        this.faceIndeShow = false;
      }
    },

    /**
     * 游戏卖号界面提示弹窗关闭
     */
    salePopupControllShowClose(){
      this.salePopupControllShow = false
    }
  },
  mounted() {
    this.source = "";
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$nextTick(() => {
        if (from.name == "Coupon") {
          vm.couponId = to.params.coupon_id;
        }
      });
    });
  },
  watch: {
    // #4 售价只允许数字与一位小数点（过滤非法字符，如 abc-99x）；不改提交/校验逻辑
    "infoForm.price"(val) {
      if (val == null || val === "") return;
      const clean = String(val)
        .replace(/[^\d.]/g, "")
        .replace(/(\..*?)\./g, "$1");
      if (clean !== String(val)) {
        this.infoForm.price = clean;
      }
    },
    step(val) {
      switch (val) {
        case 0:
          this.breadcrumbList = [{ name: "我要卖" }, { name: "官网寄售" }];
          break;
        case 1:
          this.breadcrumbList = [
            { name: "我要卖" },
            { name: "官网寄售" },
            { name: `选择游戏-${this.selectGame.game_name}` }
          ];
          break;
        case 2:
          this.breadcrumbList = [
            { name: "我要卖" },
            { name: "官网寄售" },
            { name: `选择游戏-${this.selectGame.game_name}` },
            { name: `商品类型-${this.productType}` }
          ];
          apiGetServicesInfo({
            // game_id: 0
            game_id: this.selectGame.game_id
          }).then(res => {
            this.willing_sell = res.data.willing_sell;
            this.coupon_info = res.data.willing_sell.coupon_info;
            this.currentCoupon = this.coupon_info?.list?.[0];
          });
          break;
        case 3:
          this.breadcrumbList = [
            { name: "我要卖" },
            { name: "官网寄售" },
            { name: "发布成功" }
          ];
          break;
      }
    },
    c1FormText(val) {
      if (
        this.c1Item.length == Object.keys(this.c1FormText).length &&
        this.stationLetter.game_id &&
        this.c1Item.length
      ) {
        setTimeout(() => {
          this.c1Next();
        }, 400);
      }
    },
    selectGame(val) {
      if(this.isEdit) {
        return
      }
      switch (val.screenshot_way) {
        case 0:
        this.infoForm.screenshot_method = "1";
          //截图方式
          this.screenshotList = [
            { value: "1", label: "游严选官方截图" },
            { value: "0", label: "自主截图" }
          ];
          break;
        case 1:
          this.infoForm.screenshot_method = "1";
          this.screenshotList = [{ value: "1", label: "游严选官方截图" }];
          break;
        case 2:
          this.infoForm.screenshot_method = "0";
          this.screenshotList = [{ value: "0", label: "自主截图" }];
          break;
      }
    }
  },
  computed: {
    // 王者荣耀判断：与后端对齐，使用稳定的 game_alias 而非会随环境变动的数字 gameId
    isWzry() {
      return !!(this.selectGame && this.selectGame.game_alias === 'wzry')
    },
    editType() {
      // 待跟进/二次编辑失败 1  在售 2
      return ['1', '2'].includes(this.statusType) ? '1' : '2'
    },
    couponTotal() {
      if (this.coupon_info && this.coupon_info.list.length == 0) {
        return this.willing_sell.price;
      } else {
        return (
          accSub(
            Number(this.willing_sell.price),
            Number((this.currentCoupon && this.currentCoupon.amount) || 0)
          ) || 0.01
        );
      }
    },
    hpjyDesc(){
      let desc = ''
      switch (this.equipmentForm?.volume){
        case '0':
          desc = `${this.equipmentForm.num || 0}个和平精英车币，总价${this.equipmentForm.num * this.equipmentForm.sell_price}元。`
        break;
        case '1':
          desc = `${this.equipmentForm.num || 0}个和平精英碎片，总价${this.equipmentForm.sell_price || 0}元。`
        break;
      }
      return desc
      // return `${this.equipmentForm.num || 0}个和平精英车币，总价${this.equipmentForm.num * this.equipmentForm.sell_price}元。`
    }
},
beforeRouteEnter(to,from,next){
    next((vm) => {
      vm.source_page = from.name
      vm.$sensorsTrack.AccSellView(from.name)
    })
  }
}
</script>

<!-- 弹框 -->
<style lang="less">
.screenshot-tips_isedit {
  width: 198px;
  font-size: 12px;
  color: var(--brand-blue, #1A1D24);
  display: flex;
  align-items: flex-end;
}
.ssmQuestion {
  border-radius: 4px;

  .el-dialog__header,
  .el-dialog__body {
    padding: 0 !important;
  }

  #ssmQuestion {
    position: relative;
    padding: 25px 37px 31px 32px;

    .answer {
      margin: 10px 0;

      .title {
        display: flex;
        align-items: center;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: var(--text-main, #111827);

        span {
          display: inline-block;
          width: 6px;
          height: 16px;
          background: var(--brand-blue, #1A1D24);
          margin: 0 8px 0 0;
        }
      }

      .text {
        margin: 5px 0 0;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
      }
    }
    .close {
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -40px;
      left: calc(50% - 15px);
      cursor: pointer;
    }
  }

  #exposureDialog {
    position: relative;
    padding: 18px 23px 26px 19px;
    > .exposureDialog_header {
      font-size: 20px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #111827);
      margin: 0 0 10px;
      padding: 0 0 10px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      width: 344px;
      text-align: center;
    }
    .answer {
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 19px;
      margin: 0 0 8px;
      span {
        display: inline-block;
        width: 6px;
        height: 16px;
        background: var(--brand-blue, #1A1D24);
      }
    }
    .exposureDialog_tip {
      height: 30px;
      background: var(--danger-soft, #FEF2F2);
      border-radius: 4px 4px 4px 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--danger, #EF4444);
      img {
        width: 20px;
        height: 21px;
        margin: 0 10px 0 0;
      }
    }
    .close {
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -40px;
      left: calc(50% - 15px);
      cursor: pointer;
    }
  }
}

.camp_accountDialog {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  max-height: 660px;
  background: transparent;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  #camp_accountDialog {
    width: 1157px;

    .content {
      width: 100%;
      object-fit: contain;
    }

    .btn {
      position: absolute;
      top: 15px;
      right: -75px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less" scoped>
.myDialog-btn {
  width: 250px;
  height: 40px;
  line-height: 40px;
  border-radius: 4px 4px 4px 4px;
  text-align: center;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  background: var(--primary, #FF7A1A);
  color: #ffffff;
  cursor: pointer;
}
.myDialog-notAllowed {
  background: var(--border-soft, #E8E4DE);
  color: var(--text-secondary, #5A5F6B);
  cursor: not-allowed;
}
/*在谷歌下移除input[number]的上下箭头*/
.el-input__inner[type="number"]::-webkit-outer-spin-button,
/deep/ .el-input__inner[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

/*在firefox下移除input[number]的上下箭头*/
.el-input__inner[type="number"] {
  -moz-appearance: textfield;
}

.accountSell {
  width: 1200px;
  margin: 0 auto;

  .header {
    width: calc(1200px - 88px);
    height: 100px;
    background: var(--bg-dark, #1A1D24);
    border-radius: 4px 4px 0 0;
    padding: 0 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .headTitle {
      display: flex;
      flex-direction: row;
      align-items: center;

      .headText {
        font-size: 24px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 900;
        letter-spacing: -0.5px;
        text-align: CENTER;
        color: #ffffff;
        margin: 0 24px 0 8px;
      }

      .headTip {
        height: 28px;
        line-height: 28px;
        padding: 0 12px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.14);
        border: 1px solid rgba(255, 255, 255, 0.24);
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.9);
      }
    }

    .headBack {
      height: 36px;
      line-height: 34px;
      padding: 0 16px;
      border: 1px solid rgba(255, 255, 255, 0.55);
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.12);
      font-size: 15px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 500;
      color: #ffffff;
      cursor: pointer;
      box-sizing: border-box;
      transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  .introduce {
    margin: 0 0 18px;

    .introduceHead {
      margin: 18px 0 4px;
    }

    .introduceBody {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;

      .IB_card {
        margin: 3px 0 0;
        width: 640px;
        height: 144px;
        padding: 23px 34px 23px 43px;
        background: var(--bg-card, #FFFFFF);
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .card_title {
          font-size: 20px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: var(--warning, #F59E0B);
          line-height: 20px;

          span {
            display: inline-block;
            width: 4px;
            height: 14px;
            background: var(--warning, #F59E0B);
            margin: 0 14px 0 0;
          }
        }

        .card_text {
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          line-height: 25px;
        }

        .card_tip {
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--primary, #FF7A1A);
          line-height: 16px;
        }
      }

      img {
        cursor: pointer;
      }
    }
  }

  .step1 {
    width: 1160px;
    background: var(--bg-card, #FFFFFF);
    padding: 30px 20px 60px;

    .head {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 0 0 30px;

      .title {
        display: flex;
        align-items: center;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: var(--text-main, #111827);
        margin: 0 32px 0 0;

        span {
          width: 10px;
          height: 20px;
          background: var(--brand-blue, #1A1D24);
          margin: 0 14px 0 0;
          display: inline-block;
        }
      }

      .gameImg {
        width: 50px;
        height: 50px;
        border-radius: 4px;
        margin: 0 21px 0 0;
      }

      .gameName {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        margin: 0 27px 0 0;
      }

      .btn {
        width: 100px;
        height: 30px;
        line-height: 30px;
        background: var(--primary, #FF7A1A);
        border-radius: 4px;
        cursor: pointer;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: CENTER;
        color: #ffffff;
      }
    }

    .content1_content {
      padding: 20px 25px;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      display: flex;
      flex-direction: column;
      position: relative;

      .C1C_cardList {
        display: flex;
        flex-direction: row;
        //justify-content: space-between;
        overflow: hidden;

        .C1C_card {
          width: 175px;
          padding: 0 5px;
          flex-shrink: 0; /* 用数值来收缩比例 默认值为1 */

          .C1C_card_title {
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: center;
            color: var(--text-main, #111827);
            margin: 0 0 18px;
          }

          .C1C_card_search {
            height: 40px;
            background: var(--bg-card, #FFFFFF);
            //border: 1px solid #dedede;
            border-radius: 4px;

            /deep/ .el-input__inner:focus {
              border-color: var(--primary, #FF5A1F) !important;
              box-shadow: none;
            }
          }

          .C1C_card_list {
            height: 320px;
            background: var(--bg-card, #FFFFFF);
            border: 1px solid var(--border-soft, #E8E4DE);
            overflow: auto;

            .C1C_card_item {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0 20px;
              height: 40px;
              line-height: 40px;
              background: var(--bg-card, #FFFFFF);
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Light;
              font-weight: 300;
              text-align: left;
              color: var(--text-secondary, #5A5F6B);
              cursor: pointer;

              span {
                display: flex;
                flex-direction: row;
                align-items: center;
              }

              .smqk {
                display: flex;
              }
            }

            .C1C_card_item:hover {
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: var(--brand-blue, #1A1D24);
              background: var(--brand-blue-light, #F0EDE8);
            }

            .C1C_card_itemSelect {
              padding: 0 20px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: var(--brand-blue, #1A1D24);
              background: var(--brand-blue-light, #F0EDE8);
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;

              span {
                display: flex;
                flex-direction: row;
                align-items: center;
              }
            }
          }

          ::-webkit-scrollbar {
            width: 4px; /*对垂直流动条有效*/
            height: 10px; /*对水平流动条有效*/
            display: none;
          }

          /*定义滚动条的轨道颜色、内阴影及圆角*/

          ::-webkit-scrollbar-track {
            border-radius: 2px;
          }

          /*定义滑块颜色、内阴影及圆角*/

          ::-webkit-scrollbar-thumb {
            border-radius: 2px;
            background: var(--brand-blue, #1A1D24);
          }

          /*定义两端按钮的样式*/

          ::-webkit-scrollbar-button {
            background-color: none;
          }

          /*定义右下角汇合处的样式*/

          ::-webkit-scrollbar-corner {
            background: var(--bg-section, #F7F5F2);
          }
        }

        .C1C_card:hover {
          ::-webkit-scrollbar {
            display: block;
          }
        }
      }

      .C1C_selected {
        margin: 20px 0 0 5px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .C1C_selectedTip {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-main, #111827);
        }

        .C1C_selectedOption {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--brand-blue, #1A1D24);

          span:last-of-type {
            i {
              display: none;
            }
          }
        }

        .C1C_selectedBtn {
          width: 60px;
          height: 30px;
          background: var(--bg-card-soft, #F0EDE8);
          border-radius: 4px;
          line-height: 30px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: center;
          color: var(--text-muted, #9AA0AC);
          cursor: pointer;
        }
      }

      .C1C_cardListBtn {
        position: absolute;
        cursor: pointer;
        width: 20px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: rgba(26, 29, 36, 0.28);
        color: #ffffff;
      }

      .C1C_cardListBtn:hover {
        background: rgba(26, 29, 36, 0.5);
      }

      .leftBtn {
        left: 0px;
        top: 210px;
      }

      .rightBtn {
        right: 0px;
        top: 210px;
      }
    }

    .nextBtn {
      margin: 65px auto 0;
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 800;
      text-align: CENTER;
      color: #ffffff;
      width: 300px;
      height: 50px;
      line-height: 50px;
      background: var(--primary, #FF5A1F);
      border-radius: 3px;
      box-shadow: 0 6px 16px rgba(26, 29, 36, .10);
      cursor: pointer;
    }

    .nextBtn:hover {
      background: var(--primary-hover, #E84A12);
    }
  }

  .step2 {
    /* 两栏布局：左表单流 + 右侧发布须知 */
    .sellLayout {
      display: grid;
      grid-template-columns: minmax(0, 1fr) 312px;
      gap: 20px;
      align-items: start;
    }
    .sellLayout__main {
      min-width: 0;
    }
    /* 右侧发布须知（次要，无橙强调，深炭/暖灰卡） */
    .sellNotice {
      position: sticky;
      top: 14px;
      align-self: start;
      display: flex;
      flex-direction: column;
      gap: 16px;
      margin-top: 18px;
    }
    .sellNotice__card {
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      overflow: hidden;
    }
    .sellNotice__head {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 14px 16px;
      background: var(--bg-dark, #1A1D24);
      color: #fff;
      b {
        font-size: 14px;
        font-weight: 800;
      }
      em {
        font-style: normal;
        font-size: 10px;
        letter-spacing: 1.5px;
        color: #5a5f6b;
        font-weight: 700;
        margin-left: auto;
      }
    }
    .sellNotice__shield {
      color: var(--gold, #C9974D);
      display: flex;
      flex: none;
    }
    .sellNotice__list {
      padding: 6px 0;
    }
    .sellNotice__row {
      display: flex;
      align-items: center;
      gap: 11px;
      padding: 12px 16px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      &:last-child {
        border-bottom: 0;
      }
    }
    .sellNotice__ic {
      width: 30px;
      height: 30px;
      flex: none;
      border-radius: 3px;
      background: var(--bg-dark, #1A1D24);
      color: var(--gold, #C9974D);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .sellNotice__tx {
      font-size: 13px;
      color: var(--text-secondary, #5A5F6B);
      line-height: 1.45;
      b {
        color: var(--text-main, #111827);
        font-weight: 800;
      }
    }
    .sellNotice__trust {
      display: flex;
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      overflow: hidden;
      background: var(--bg-card, #FFFFFF);
      div {
        flex: 1;
        text-align: center;
        padding: 14px 6px;
        border-right: 1px solid var(--border-soft, #E8E4DE);
        &:last-child {
          border-right: 0;
        }
      }
      b {
        display: block;
        font-size: 18px;
        font-weight: 900;
        color: var(--text-main, #111827);
        letter-spacing: -0.5px;
      }
      span {
        display: block;
        font-size: 11px;
        color: var(--text-muted, #9AA0AC);
        margin-top: 3px;
      }
    }
    @media (max-width: 1080px) {
      .sellLayout {
        grid-template-columns: 1fr;
      }
      .sellNotice {
        position: static;
      }
    }

    .account,
    .equip {
      .form {
        .card {
          background: var(--bg-card, #FFFFFF);
          padding: 0 0 30px;
          // ?
          .question {
            margin: 0 0 0 21px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: LEFT;
            color: var(--danger, #EF4444);
            display: flex;
            align-items: center;
            cursor: pointer;
            vertical-align: middle;

            img {
              width: 20px;
              height: 20px;
              margin: 0 2px 0 0;
            }
          }

          //内容插槽
          .content {
            display: flex;
            align-items: center;
            //提示
            .tip {
              margin: 0 0 0 10px;
              font-size: 16px;
              font-family: PingFangSC-Thin, PingFang SC;
              font-weight: 300;
              color: var(--text-secondary, #5A5F6B);
            }
          }

          //单选框
          .radio{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            .option {
              padding: 0 19px;
              min-width: 100px;
              height: 48px;
              background: var(--bg-section, #F7F5F2);
              border: 1px solid var(--border-soft, #E8E4DE);
              border-radius: 4px;
              font-size: 16px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              text-align: CENTER;
              color: var(--text-secondary, #5A5F6B);
              line-height: 48px;
              margin: 0 15px 0 0;
              cursor: pointer;
            }

            .optionSelect {
              background: var(--primary-soft, #FFEDE6);
              color: var(--primary, #FF5A1F);
              border: 1px solid var(--primary, #FF5A1F);
            }

            .option:hover {
              animation: grid-contentMove 0.2s linear infinite; // 重点，定义动画
              animation-fill-mode: forwards;
              animation-iteration-count: 1;
              position: relative;
              z-index: 999999;
              @keyframes grid-contentMove {
                0% {
                  transform: translateY(0);
                }
                100% {
                  transform: translateY(-2px);
                }
              }
            }
          }

          //输入框
          .input {
            width: 222px;

            /deep/ .el-input__inner {
              width: 222px;
              background: var(--bg-section, #F7F5F2);
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-main, #111827);
              border: 1px solid var(--border-soft, #E8E4DE);
            }

            /deep/ .el-input__inner:focus {
              border: 1px solid var(--primary, #FF5A1F);
              box-shadow: none;
            }

            /deep/ .el-input__inner::-webkit-input-placeholder {
              color: var(--text-muted, #9AA0AC);
            }
          }
          .select {
            width: 222px;
            /deep/ .el-input__inner {
              width: 222px;
              background: var(--bg-section, #F7F5F2);
              font-size: 14px;
            }
            /deep/ .el-input__inner:focus {
              border: 1px solid var(--primary, #FF5A1F);
              box-shadow: none;
            }

            /deep/ .el-input__inner::-webkit-input-placeholder {
              color: var(--text-muted, #9AA0AC);
            }
          }
          //标题 输入框  特殊的
          .nameInput {
            width: 100% !important;

            /deep/ .el-input__inner {
              width: 100% !important;
            }

            /deep/ .el-input__count-inner {
              background: transparent;
            }
          }

          //上传
          .upload {
            .upload_image {
              width: 100%;
              height: 100%;
              border-radius: 4px;
            }

            /deep/ .el-upload--picture-card {
              border: 2px dashed var(--border-soft, #E8E4DE);
              border-radius: 4px;
              background: var(--bg-tag, #F0EDE8);
              transition: border-color .2s var(--ease, ease), color .2s var(--ease, ease);

              i {
                color: var(--text-secondary, #5A5F6B);
              }
            }

            /deep/ .el-upload--picture-card:focus,
            /deep/ .el-upload--picture-card:hover {
              border-color: var(--primary, #FF5A1F);

              i {
                color: var(--primary, #FF5A1F);
              }
            }
          }
          //上传缩略图圆角
          /deep/ .el-upload-list--picture-card .el-upload-list__item {
            border-radius: 4px;
          }
          /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
            border-radius: 4px;
          }

          //多行文本框
          .textarea {
            /deep/ .el-textarea__inner:focus {
              border-color: var(--primary, #FF5A1F);
              box-shadow: none;
            }
          }

          //提示框
          .tip {
            span {
              font-size: 16px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--primary, #FF7A1A);
            }

            .priceTip {
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: var(--danger, #EF4444);
            }
          }
          .coupon {
            background: url("../../../assets/image/Coupon/bubbleFrame.png") no-repeat;
            color: #585858;
            display: flex;
            flex-direction: column;
            position: absolute;
            margin-top: -15px;
            width: 600px;
            font-size: 16px;
            background-size: 100% 100%;
            padding: 20px 42px 25px;
            .price {
              font-weight: bold;
              font-size: 20px;
              color: black;
            }
            .empty {
              color: #b6b6b6;
            }
            .line1 {
              display: flex;
              justify-content: space-between;
              margin-top: 15px;
            }
            .line2 {
              display: flex;
              justify-content: space-between;
              margin-top: 15px;
              .choose {
                color: var(--primary, #FF7A1A);
                font-size: 13px;
                margin-left: 10px;
                cursor: pointer;
                img{
                  width: 11px;
                  margin-bottom: -1px;
                  margin-left: -1px;
                }
              }
            }
            .line3 {
              display: flex;
              justify-content: space-between;
              margin-top: 15px;
            }
            .line4 {
              display: flex;
              margin-top: 15px;
              .tips {
                background: url("../../../assets/image/Coupon/errTip.png");
                width: 15px;
                height: 15px;
                margin-right: 10px;
                display: inline-block;
                background-size: cover;
                margin-top: 1px;
              }
            }
          }
        }

        .submit {
          display: flex;
          flex-direction: column;
          align-items: center;
          background: var(--bg-card, #FFFFFF);
          padding: 24px 0 124px;
          margin-top: 18px;
          border-top: 1px solid var(--border-soft, #E8E4DE);

          .btn {
            cursor: pointer;
            width: 300px;
            height: 50px;
            line-height: 50px;
            background: var(--primary, #FF5A1F);
            border-radius: 3px;
            box-shadow: 0 6px 16px rgba(26, 29, 36, .10);
            font-size: 18px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 800;
            text-align: CENTER;
            color: #ffffff;
            transition: background .2s var(--ease, ease), transform .2s var(--ease, ease);
          }

          .btn:hover {
            background: var(--primary-hover, #E84A12);
            transform: translateY(-1px);
          }

          .tip {
            width: 1072px;
            margin: 30px 0 0;
            background: var(--brand-blue-light, #F0EDE8);
            padding: 14px 30px;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            border-radius: 4px;
            .title {
              font-size: 18px;
              font-weight: 600;
              color: var(--text-main, #111827);
            }
            div {
              margin-bottom: 10px;
            }

            span {
              font-weight: 500;
              margin: 0 0 0 5px;
              color: var(--brand-blue, #1A1D24);
              position: relative;
              cursor: pointer;
              &::after {
                content: "";
                width: 78px;
                height: 1px;
                position: absolute;
                bottom: -1px;
                left: 10px;
                background: var(--brand-blue, #1A1D24);
              }
            }
          }
        }
      }
    }
  }

  .step3 {
    position: relative;
    .step3_source {
      height: 258px;
      box-sizing: border-box;
      background: var(--bg-card, #FFFFFF);
      margin-top: 10px;
      padding: 34px 0 65px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .source_title {
        width: 970px;
        color: var(--border-soft, #E8E4DE);
        .el-divider__text {
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: var(--text-muted, #9AA0AC);
        }
      }
      .scource_radio {
        box-sizing: border-box;
        width: 970px;
        margin-top: 6px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 0 25px 0 45px;
        // .el-radio.is-bordered+.el-radio.is-bordered,.el-radio{
        //   margin: 0;
        // }
        .el-radio {
          padding: 0;
          width: 130px;
          height: 42px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 20px 10px 0;
          background: var(--bg-section, #F7F5F2);
          border-radius: 4px 4px 4px 4px;
          border-color: var(--border-soft, #E8E4DE);
        }
        /deep/.el-radio__input {
          display: none;
        }
        /deep/.el-radio__label {
          padding: 0;
          font-size: 16px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: var(--text-secondary, #5A5F6B);
        }
        .el-radio.is-bordered.is-checked {
          border: 1px solid rgba(26, 29, 36, 0.28);
          background: var(--brand-blue-light, #F0EDE8);
          /deep/.el-radio__label {
            color: var(--brand-blue, #1A1D24);
          }
        }
      }
    }
    .step3_success {
      padding: 45px 0 57px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      background: var(--bg-card, #FFFFFF);
      font-family: PingFang SC-Medium, PingFang SC;

      .success_title {
        font-size: 26px;
        font-weight: 500;
        color: var(--brand-blue, #1A1D24);
        margin-bottom: 12px;
        img {
          width: 40px;
          height: 40px;
          vertical-align: bottom;
        }
      }
      .success_info {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        width: 340px;
        line-height: 24px;
        margin-bottom: 4px;
        .label {
          width: 85px;
          font-size: 16px;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
        }
        .label_info {
          font-size: 16px;
          font-weight: 500;
          color: var(--text-main, #111827);
          span {
            font-size: 12px;
            font-weight: 500;
            color: var(--primary, #FF7A1A);
            cursor: pointer;
            i {
              margin-right: 2px;
            }
          }
        }
      }
      .success_btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
      }
    }
    .btn {
      width: 188px;
      height: 42px;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-strong, #CBD5E1);
      border-radius: 4px;
      font-size: 18px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      color: var(--text-main, #111827);
      line-height: 42px;
      text-align: center;
      cursor: pointer;
    }

    .cusSerBtn {
      background: var(--primary, #FF7A1A);
      border: 1px solid var(--primary, #FF7A1A);
      color: #ffffff;
      margin-right: 10px;
    }

    .tip {
      margin: 10px 0 0 0;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-main, #111827);
    }

    .downlandAPP {
      position: absolute;
      top: 45px;
      right: 100px;
      img {
        width: 183px;
        height: 262px;
      }
    }
  }
}
.myDialog-btn-group{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .btn-default{
      width: 140px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid var(--border-strong, #CBD5E1);
      color: var(--text-main, #111827);
      font-family: PingFang SC;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .btn-cancel{
      background: var(--bg-card, #FFFFFF);
    }
    .btn-confirm{
      border-color: var(--primary, #FF7A1A);
      background: var(--primary, #FF7A1A);
      color: #ffffff;
    }
  }
</style>
